import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
  useMemo,
} from 'react';
import {
  Grid,
  Container,
  useTheme,
  CardContent,
  Card,
  Hidden,
  Divider,
  Button,
  Box,
} from '@mui/material';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import reviewschool from '../../../assets/reviewschool.png';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import banner from '../../../assets/banner.png';
import MenuTTdemo from '../../../assets/MenuTTdemo.png';
import menuAlyosef from '../../../assets/alyousef/Menu Image.png';
import TableTuck from '../../../assets/menufilfil.png';
import ttjordanbanner from '../../../assets/ttjordanbanner2.png';
import noItems from '../../../assets/Hamburger-pana 1.png';
import KeyboardDoubleArrowRightTwoToneIcon from '@mui/icons-material/KeyboardDoubleArrowRightTwoTone';
import KeyboardDoubleArrowLeftTwoToneIcon from '@mui/icons-material/KeyboardDoubleArrowLeftTwoTone';

import './index.css';
import { useSelector } from 'react-redux';
import CustomizeDialoge from '../../components/CustomizeDialoge/CustomizeDialoge';
import { environment } from '../../../environments/environment';
import { useTranslation } from 'react-i18next';
import {
  menues,
  res,
  setModifiers,
  setUser,
  LoadItems,
  LoadCategories,
  setStores,
} from '../../../../../../libs/redux-slices/src';
import { auth, firestore } from '../../../../../../libs/firebase-service/src';
import { persistor } from '../../../../../../libs/redux-slices/src';
import { useDispatch } from 'react-redux';
import { fetchData } from '../../Utils/UtilsFunctions';
import Loading from 'react-fullscreen-loading';
import { Helmet } from 'react-helmet';
import { FiMinusSquare } from 'react-icons/fi';
import popularImage from './../../../assets/popular.png';
import SectionHeader from '../../components/common/SectionHeader';
import FattyPattyMenuCard from '../../components/FattyPattyMenuCard';
import FattyPattyDialog from '../../components/FattyPattyDialog';
import DeliveryDialog from '../../components/CartDrawer/DeliveryDialog';
import ChangeBranchMenu from './changeBranchMenu';
import SchedulingDialog from '../../components/SchedulingDialog/SchedulingDialog';
import LocationStoreSelector from '../../components/common/LocationStoreSelector';
import { useUserLocation } from '../../hooks/useUserLocation';
import { useNearestStore } from '../../hooks/useNearestStore';
import { useAnonymousAuth } from '../../hooks/useAnonymousAuth';
import { useDeliveryAddress } from '../../hooks/useDeliveryAddress';
import {
  getCompleteMenuByStore,
  setUserDefaultStore,
} from '../../services/storeMenuService';
import { getStoreStatus } from '../../Utils/storeTimingUtils';
import { MdSchedule, MdClose, MdFlashOn } from 'react-icons/md';
import { UpdateScheduledTime, UpdateCartData } from '@tabletuck/redux-slices';

/** Set to true to log why each category is displayed or hidden (including time-gated windows). */
const DEBUG_CATEGORY_DISPLAY = true;

/**
 * Check if a category is currently available based on its availability periods
 * @param {Array} availabilityPeriods - Array of availability period objects (can be availability_periods or availabilityPeriods)
 * @param {string} storeTimezone - The store's timezone (e.g., 'America/New_York')
 * @param {string} storeId - The current store ID to check location-based availability
 * @param {Object} scheduledTime - Optional scheduled time object from Redux state
 * @returns {boolean} - True if category is available now, false otherwise
 */
const isCategoryAvailable = (
  availabilityPeriods,
  storeTimezone = null,
  storeId = null,
  scheduledTime = null
) => {
  // If no availability periods defined, category is always available
  if (!availabilityPeriods || availabilityPeriods.length === 0) {
    return true;
  }

  // Filter out deleted periods
  const activePeriods = availabilityPeriods.filter(
    (period) => !period.isDeleted && period.type === 'AVAILABILITY_PERIOD'
  );

  // If all periods are deleted, category is always available
  if (activePeriods.length === 0) {
    return true;
  }

  const now = new Date();

  // Map day names to ensure consistency (Square uses 3-letter codes)
  const dayMapping = {
    0: 'SUN', // Sunday
    1: 'MON', // Monday
    2: 'TUE', // Tuesday
    3: 'WED', // Wednesday
    4: 'THU', // Thursday
    5: 'FRI', // Friday
    6: 'SAT', // Saturday
  };

  // ========== SCHEDULED TIME LOGIC ==========
  let checkTime, checkDay;
  let useScheduledTime = false;

  // Validate scheduled time before using it - USE dateOfOrder, not sendTime
  if (scheduledTime && scheduledTime.dateOfOrder) {
    const scheduledDate = new Date(scheduledTime.dateOfOrder);

    // Check if the date is valid
    if (!isNaN(scheduledDate.getTime())) {
      useScheduledTime = true;

      // Get day and time from scheduled date in store's timezone
      if (storeTimezone) {
        try {
          const normalizedTimezone = storeTimezone
            .toLowerCase()
            .split('/')
            .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
            .join('/');

          const storeFormatter = new Intl.DateTimeFormat('en-US', {
            timeZone: normalizedTimezone,
            weekday: 'short',
          });
          checkDay = storeFormatter.format(scheduledDate).toUpperCase();

          const storeTimeFormatter = new Intl.DateTimeFormat('en-US', {
            timeZone: normalizedTimezone,
            hour12: false,
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          });
          checkTime = storeTimeFormatter.format(scheduledDate);
        } catch (error) {
          checkDay = dayMapping[scheduledDate.getDay()];
          checkTime = scheduledDate.toLocaleTimeString('en-US', {
            hour12: false,
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          });
        }
      } else {
        checkDay = dayMapping[scheduledDate.getDay()];
        checkTime = scheduledDate.toLocaleTimeString('en-US', {
          hour12: false,
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        });
      }
    } else {
      // Invalid scheduled time format
      useScheduledTime = false;
    }
  } else {
    useScheduledTime = false;
  }

  // ========== CURRENT TIME LOGIC (only used if no scheduled time) ==========
  let currentDay, currentTime;

  if (!useScheduledTime) {
    if (storeTimezone) {
      try {
        // Normalize timezone format (AMERICA/NEW_YORK -> America/New_York)
        const normalizedTimezone = storeTimezone
          .toLowerCase()
          .split('/')
          .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
          .join('/');

        // Use Intl.DateTimeFormat to get day in store timezone
        const storeFormatter = new Intl.DateTimeFormat('en-US', {
          timeZone: normalizedTimezone,
          weekday: 'short',
        });
        const storeDayName = storeFormatter.format(now).toUpperCase();
        currentDay = storeDayName;

        // Get time in store timezone
        const storeTimeFormatter = new Intl.DateTimeFormat('en-US', {
          timeZone: normalizedTimezone,
          hour12: false,
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        });
        currentTime = storeTimeFormatter.format(now);
      } catch (error) {
        // Fallback to local timezone if store timezone is invalid
        currentDay = dayMapping[now.getDay()];
        currentTime = now.toLocaleTimeString('en-US', {
          hour12: false,
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        });
      }
    } else {
      // Fallback to local timezone
      currentDay = dayMapping[now.getDay()];
      currentTime = now.toLocaleTimeString('en-US', {
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });
    }
  }

  // Helper function to check if availability period applies to current store
  const isAvailableAtLocation = (period, currentStoreId) => {
    if (!currentStoreId) {
      // If no store ID provided, assume period applies (fallback behavior)
      return true;
    }

    const {
      presentAtAllLocations = false,
      presentAtLocationIds = [],
      absentAtLocationIds = [],
    } = period;

    // If present at all locations, check if current store is not in absent list
    if (presentAtAllLocations) {
      return !absentAtLocationIds.includes(currentStoreId);
    }

    // If not present at all locations, check if current store is in present list
    return presentAtLocationIds.includes(currentStoreId);
  };

  // ========== FINAL DECISION: Which time to check ==========
  const finalCheckDay = useScheduledTime ? checkDay : currentDay;
  const finalCheckTime = useScheduledTime ? checkTime : currentTime;

  // Check if time (scheduled or current) falls within any availability period that applies to this store
  const isAvailable = activePeriods.some((period, periodIndex) => {
    try {
      // Step 1: Check if period has data
      if (!period.availabilityPeriodData) {
        return false;
      }

      // Step 2: Check location availability
      const locationApplies = isAvailableAtLocation(period, storeId);

      if (!locationApplies) {
        return false;
      }

      const { dayOfWeek, startLocalTime, endLocalTime } =
        period.availabilityPeriodData;

      // Step 3: Validate required fields

      if (!dayOfWeek || !startLocalTime || !endLocalTime) {
        return false;
      }

      // Step 4: Check if it's the right day (normalize to uppercase for comparison)
      const normalizedDayOfWeek = dayOfWeek.toUpperCase();
      const dayMatch = normalizedDayOfWeek === finalCheckDay;

      if (!dayMatch) {
        return false;
      }

      // Step 5: Check if time (scheduled or current) is within the available time range

      // Convert time strings to minutes for proper numerical comparison
      const timeToMinutes = (timeStr) => {
        const [hours, minutes, seconds] = timeStr.split(':').map(Number);
        return hours * 60 + minutes + (seconds || 0) / 60;
      };

      const checkMinutes = timeToMinutes(finalCheckTime);
      const startMinutes = timeToMinutes(startLocalTime);
      const endMinutes = timeToMinutes(endLocalTime);

      // Handle cases where end time is before start time (spans midnight)
      let isWithinTimeRange;
      const spansMidnight = endMinutes < startMinutes;

      if (spansMidnight) {
        // Time period spans midnight (e.g., 22:00 to 06:00)
        isWithinTimeRange =
          checkMinutes >= startMinutes || checkMinutes <= endMinutes;
      } else {
        // Normal time period (e.g., 03:00 to 07:00)
        isWithinTimeRange =
          checkMinutes >= startMinutes && checkMinutes <= endMinutes;
      }

      return isWithinTimeRange;
    } catch (error) {
      return false; // If there's an error, assume not available
    }
  });

  return isAvailable;
};

/**
 * Returns { available, reason, timeWindows } for debugging category display.
 * timeWindows: Array<{dayOfWeek, startLocalTime, endLocalTime}> for "would show during" when not available now.
 */
const getCategoryAvailabilityDebug = (
  availabilityPeriods,
  storeTimezone = null,
  storeId = null,
  scheduledTime = null
) => {
  if (!availabilityPeriods || availabilityPeriods.length === 0) {
    return {
      available: true,
      reason: 'no availability periods; always shown',
      timeWindows: [],
    };
  }

  const activePeriods = availabilityPeriods.filter(
    (p) => !p.isDeleted && p.type === 'AVAILABILITY_PERIOD'
  );
  if (activePeriods.length === 0) {
    return {
      available: true,
      reason: 'all periods deleted or invalid; always shown',
      timeWindows: [],
    };
  }

  const dayMapping = {
    0: 'SUN',
    1: 'MON',
    2: 'TUE',
    3: 'WED',
    4: 'THU',
    5: 'FRI',
    6: 'SAT',
  };

  let checkTime,
    checkDay,
    useScheduledTime = false;
  if (scheduledTime && scheduledTime.dateOfOrder) {
    const scheduledDate = new Date(scheduledTime.dateOfOrder);
    if (!isNaN(scheduledDate.getTime())) {
      useScheduledTime = true;
      if (storeTimezone) {
        try {
          const n = storeTimezone
            .toLowerCase()
            .split('/')
            .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
            .join('/');
          checkDay = new Intl.DateTimeFormat('en-US', {
            timeZone: n,
            weekday: 'short',
          })
            .format(scheduledDate)
            .toUpperCase();
          checkTime = new Intl.DateTimeFormat('en-US', {
            timeZone: n,
            hour12: false,
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          }).format(scheduledDate);
        } catch {
          checkDay = dayMapping[scheduledDate.getDay()];
          checkTime = scheduledDate.toLocaleTimeString('en-US', {
            hour12: false,
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          });
        }
      } else {
        checkDay = dayMapping[scheduledDate.getDay()];
        checkTime = scheduledDate.toLocaleTimeString('en-US', {
          hour12: false,
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        });
      }
    }
  }

  const now = new Date();
  let currentDay, currentTime;
  if (!useScheduledTime && storeTimezone) {
    try {
      const n = storeTimezone
        .toLowerCase()
        .split('/')
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join('/');
      currentDay = new Intl.DateTimeFormat('en-US', {
        timeZone: n,
        weekday: 'short',
      })
        .format(now)
        .toUpperCase();
      currentTime = new Intl.DateTimeFormat('en-US', {
        timeZone: n,
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      }).format(now);
    } catch {
      currentDay = dayMapping[now.getDay()];
      currentTime = now.toLocaleTimeString('en-US', {
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });
    }
  } else if (!useScheduledTime) {
    currentDay = dayMapping[now.getDay()];
    currentTime = now.toLocaleTimeString('en-US', {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  }

  const finalCheckDay = useScheduledTime ? checkDay : currentDay;
  const finalCheckTime = useScheduledTime ? checkTime : currentTime;

  const isAvailableAtLocation = (period, sid) => {
    if (!sid) return true;
    const {
      presentAtAllLocations = false,
      presentAtLocationIds = [],
      absentAtLocationIds = [],
    } = period;
    if (presentAtAllLocations) return !absentAtLocationIds.includes(sid);
    return presentAtLocationIds.includes(sid);
  };

  const timeToMinutes = (t) => {
    const [h, m, s] = (t || '').split(':').map(Number);
    return (h || 0) * 60 + (m || 0) + (s || 0) / 60;
  };

  const timeWindows = [];
  let available = false;
  let reason = '';

  for (const period of activePeriods) {
    if (!period.availabilityPeriodData) continue;
    if (!isAvailableAtLocation(period, storeId)) continue;
    const { dayOfWeek, startLocalTime, endLocalTime } =
      period.availabilityPeriodData;
    if (!dayOfWeek || !startLocalTime || !endLocalTime) continue;
    timeWindows.push({ dayOfWeek, startLocalTime, endLocalTime });

    const dayMatch = (dayOfWeek || '').toUpperCase() === finalCheckDay;
    if (!dayMatch) continue;

    const checkM = timeToMinutes(finalCheckTime);
    const startM = timeToMinutes(startLocalTime);
    const endM = timeToMinutes(endLocalTime);
    const spansMidnight = endM < startM;
    const inRange = spansMidnight
      ? checkM >= startM || checkM <= endM
      : checkM >= startM && checkM <= endM;
    if (inRange) {
      available = true;
      reason = `within availability window (${finalCheckDay} ${finalCheckTime} in ${startLocalTime}-${endLocalTime})`;
      break;
    }
  }

  if (!reason) {
    reason =
      timeWindows.length > 0
        ? 'outside availability window'
        : 'no period applies to this store';
  }

  return { available, reason, timeWindows };
};

const formatTimeWindows = (tw) => {
  if (!tw || tw.length === 0) return '';
  const dayOrder = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
  const strip = (s) => (s || '').replace(/:\d{2}$/, '') || s;
  const seen = new Set();
  const unique = tw.filter((p) => {
    const k = `${p.dayOfWeek}|${p.startLocalTime}|${p.endLocalTime}`;
    if (seen.has(k)) return false;
    seen.add(k);
    return true;
  });
  const days = [...new Set(unique.map((p) => p.dayOfWeek))].sort(
    (a, b) => dayOrder.indexOf(a) - dayOrder.indexOf(b)
  );
  const [s0, e0] = [unique[0].startLocalTime, unique[0].endLocalTime];
  const allSame = unique.every(
    (p) => p.startLocalTime === s0 && p.endLocalTime === e0
  );
  if (allSame && days.length >= 1) {
    return days.length === 7
      ? `SUN-SAT ${strip(s0)}-${strip(e0)}`
      : `${days.join(',')} ${strip(s0)}-${strip(e0)}`;
  }
  return unique
    .map(
      (p) =>
        `${p.dayOfWeek} ${strip(p.startLocalTime)}-${strip(p.endLocalTime)}`
    )
    .join(', ');
};

/**
 * Check if a category (or menu) has any channel with reference type FIRST_PARTY_INTEGRATION.
 * Such categories should not be displayed.
 * @param {Object} category - Category/menu object with channels array
 * @returns {boolean}
 */
const hasFirstPartyIntegrationChannel = (category) => {
  return (category?.channels || []).some(
    (ch) => ch?.reference?.type === 'FIRST_PARTY_INTEGRATION'
  );
};

/**
 * Check if a category is available at the given store (branch) based on its channels.
 * A category is available at a store if it has at least one channel with status ACTIVE
 * and reference.id (location id) matching the storeId. Only LOCATION channels are
 * considered; FIRST_PARTY_INTEGRATION channels are excluded from display elsewhere.
 * @param {Object} category - Category object with channels array
 * @param {string} storeId - Current store/location id (e.g. selectedStore.id)
 * @returns {boolean}
 */
const isCategoryAvailableAtStoreByChannels = (category, storeId) => {
  if (!storeId || !category?.channels?.length) {
    return false;
  }

  const refIds = (category.channels || [])
    .filter(
      (ch) => ch?.status === 'ACTIVE' && ch?.reference?.type === 'LOCATION'
    )
    .map((ch) => ch?.reference?.id);

  return refIds.includes(storeId);
};

function MenuItems2() {
  const [t, i18n] = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints.down('sm'));
  
  // Capture viewport height once on mount to avoid iOS keyboard reflow loops.
  // On iOS, when the keyboard opens, 100vh changes dynamically, causing layout
  // thrashing. This stable height is captured once and never changes.
  const [stableHeight] = useState(() =>
    typeof window !== 'undefined' ? `${window.innerHeight}px` : '100vh'
  );
  
  const [extraquantity, setExtraquantity] = useState({});
  const [extraQuantity, setExtraQuantity] = useState({});
  const [defs, setDefs] = useState([]);
  const [data, setData] = React.useState([]);
  const [openn, setOpenn] = useState(false);
  const [enableAdd, setEnableAdd] = useState(false);
  const [type, setType] = useState(
    environment?.restaurantId === 'ttJordanDev' ||
      environment?.restaurantId === 'ttJordan' ||
      environment?.restaurantId === 'fattyPattyDev' ||
      environment?.restaurantId === 'fattyPatty'
      ? ''
      : 'Popular'
  );
  const [loading, setLoading] = useState(false);
  const [option, setOption] = useState(null);
  const [open, setOpen] = useState(false);
  const [id, setId] = useState('');
  const [item, setItem] = useState(null);
  const [pendingEditCartItem, setPendingEditCartItem] = useState(
    location?.state?.editCartItem || null
  );
  const hasAppliedEditCartItemRef = useRef(false);
  const [optionsPrice1, setOptionsPrice1] = useState(0);
  const [storeId, setStoreId] = useState('');
  const [outofStockDelivery, setOutOfStockDelivery] = useState('');
  const navRef = useRef(null);
  const categorySectionRefs = useRef({});
  const isAutoScrollingCategoryRef = useRef(false);
  const categoryObserverDebounceRef = useRef(null);
  /** Fixed mobile category bar (Fatty Patty) — measured for spacer + scroll alignment */
  const categoryStickyNavRef = useRef(null);
  /** Fatty Patty `SectionHeader` wrapper — bottom edge positions the fixed category bar */
  const menuPageHeaderRef = useRef(null);
  /** Scheduled-order banner (when shown) sits under the header — include in sticky offset */
  const scheduledBannerRef = useRef(null);
  /** Viewport Y (px) where the fixed category strip sits; synced on scroll/resize */
  const stickyCategoryNavTopRef = useRef(0);
  const [mobileStickyCategoryNavHeight, setMobileStickyCategoryNavHeight] =
    useState(72);
  const dispatch = useDispatch();
  const params = useParams();
  const [locationDialogOpen, setLocationDialogOpen] = useState(false);
  const [changeBranchDialogOpen, setChangeBranchDialogOpen] = useState(false);
  const [showInitialBranchDialog, setShowInitialBranchDialog] = useState(false);
  const [hasUserCancelledDialog, setHasUserCancelledDialog] = useState(false);
  const [showSchedulingDialog, setShowSchedulingDialog] = useState(false);

  // Track if scheduling was just confirmed to prevent clearing on dialog close
  const schedulingJustConfirmedRef = useRef(false);
  // Track store open state for end-of-day: when branch closes, re-prompt for branch/time/address (even if cart has items)
  const previousStoreWasOpenRef = useRef(null);
  // When true, initial branch dialog opens with no pre-filled address (so user can re-enter after "branch closed" revalidate)
  const [
    clearAddressWhenBranchDialogOpens,
    setClearAddressWhenBranchDialogOpens,
  ] = useState(false);

  // New state for location and store selection
  const [selectedStore, setSelectedStore] = useState(null);
  const [userLocation, setUserLocation] = useState(null);
  const [storeMenuData, setStoreMenuData] = useState(null);
  const [isLoadingStoreMenu, setIsLoadingStoreMenu] = useState(false);

  // Anonymous auth session initialization
  const [isInitializingSession, setIsInitializingSession] = useState(false);

  // Location hook for getting user location automatically
  const {
    userLocation: hookUserLocation,
    isGettingLocation,
    locationError,
    getLocationWithFallbacks,
    setLocationFromAddress,
  } = useUserLocation({
    autoStart: true,
    enableConsoleLogging: false,
  });

  // Debug Google Maps API Keys being used
  // useEffect(() => {
  //   // Import and call the utility function for debugging
  //   import('../../Utils/googleMapsUtils').then(({ getGoogleMapsApiKey }) => {
  //     const selectedKey = getGoogleMapsApiKey();
  //     console.log(
  //       '🎯 Final selected Google Maps API key:',
  //       selectedKey ? `${selectedKey.substring(0, 20)}...` : 'No key available'
  //     );
  //     console.log(
  //       'Current window.google status:',
  //       typeof window.google !== 'undefined' ? 'Available' : 'Not Available'
  //     );
  //     if (typeof window.google !== 'undefined' && window.google.maps) {
  //       console.log('Google Maps API version:', window.google.maps.version);
  //     }
  //   });
  // }, []);
  // Prefer saved/delivery address for "nearest store" when user has one (so selection stays correct with empty cart)
  const userForLocation = useSelector((state) => state.authReducer.userData);
  const userAddressesForLocation = useSelector(
    (state) => state.authReducer.userAddresses
  );
  const locationForNearestStore = useMemo(() => {
    const addr =
      userAddressesForLocation?.find(
        (a) => a.id === userForLocation?.defaultDeliveryAddress
      ) || userAddressesForLocation?.[0];
    if (addr?.lat != null && addr?.lng != null) {
      return { lat: addr.lat, lng: addr.lng };
    }
    return hookUserLocation;
  }, [
    userForLocation?.defaultDeliveryAddress,
    userAddressesForLocation,
    hookUserLocation,
  ]);

  // Nearest store hook for auto-selecting nearest store
  const {
    stores,
    nearestStore,
    selectedStore: autoSelectedStore,
    isLoadingStores,
    storeError,
    selectStore,
    refreshStores,
    getStoresByDistance,
  } = useNearestStore({
    userLocation: locationForNearestStore,
    autoSelectNearest: !location?.state?.store && !params?.storeId,
    enableConsoleLogging: false,
  });

  // Anonymous auth hook for session initialization
  const { initializeAnonymousSession, isAnonymous } = useAnonymousAuth();

  const modifiers = useSelector((state) => state.shopReducer.modifiers);
  const userData = useSelector((state) => state.authReducer.userData);

  const storess = useSelector((state) => state.shopReducer.stores);
  const items = useSelector((state) => state.shopReducer.currentItem);
  const menuess = useSelector((state) => state.authReducer.menues);

  const categories = useSelector(
    (state) => state.shopReducer.currentCategories
  );

  const user = useSelector((state) => state.authReducer.userData);
  const userAddresses = useSelector((state) => state.authReducer.userAddresses);
  const scheduledTime = useSelector((state) => state.shopReducer.scheduledTime);
  const cart = useSelector((state) => state.shopReducer.cart);
  const cartData = useSelector((state) => state.shopReducer.cartData);

  // Auto-clear scheduled time when the selected slot has passed
  useEffect(() => {
    const checkExpiry = () => {
      if (scheduledTime?.dateOfOrder && new Date(scheduledTime.dateOfOrder) < new Date()) {
        dispatch(UpdateScheduledTime(null));
      }
    };
    checkExpiry();
    const interval = setInterval(checkExpiry, 60_000);
    return () => clearInterval(interval);
  }, [scheduledTime?.dateOfOrder, dispatch]);

  // Unified delivery address: includes last-selected address from branch dialog (deliveryStore) or saved addresses
  const { currentDeliveryAddressData } = useDeliveryAddress();

  // Get cart store ID and store object for auto-selection priority
  const cartStoreId = useMemo(() => {
    if (!cart?.length) return '';
    return cart[0]?.storeId ?? cart[0]?.store_id ?? '';
  }, [cart]);

  const cartStore = useMemo(() => {
    if (!cartStoreId || !stores?.length) return null;
    return stores.find((store) => store.id === cartStoreId);
  }, [cartStoreId, stores]);

  // Store used for scheduling dialog in the time banner
  const currentStoreForScheduling = useMemo(() => {
    if (selectedStore) return selectedStore;
    if (scheduledTime?.storeId && stores?.length) {
      return stores.find((store) => store.id === scheduledTime.storeId) || null;
    }
    return null;
  }, [selectedStore, scheduledTime?.storeId, stores]);

  const currentStoreStatus = useMemo(
    () =>
      currentStoreForScheduling
        ? getStoreStatus(currentStoreForScheduling)
        : null,
    [currentStoreForScheduling]
  );

  // Reusable: trigger "branch closed" re-validate (clear time, open branch dialog) — used by real end-of-day check
  const triggerBranchClosedRevalidate = useCallback(() => {
    dispatch(UpdateScheduledTime(null));
    dispatch(
      UpdateCartData({
        ...cartData,
        scheduledTime: null,
      })
    );
    setClearAddressWhenBranchDialogOpens(true);
    setShowInitialBranchDialog(true);
    setHasUserCancelledDialog(false);
  }, [dispatch, cartData]);

  // End of day: when the selected branch's closing time is reached, re-prompt for branch, time, and address (even if cart has items)
  useEffect(() => {
    if (!selectedStore) {
      previousStoreWasOpenRef.current = null;
      return;
    }
    const checkIntervalMs = 60 * 1000; // check every minute
    const tick = () => {
      const status = getStoreStatus(selectedStore);
      const isOpen = status?.isOpen === true;
      const wasOpen = previousStoreWasOpenRef.current;
      if (wasOpen === true && isOpen === false) {
        triggerBranchClosedRevalidate();
      }
      previousStoreWasOpenRef.current = isOpen;
    };
    tick(); // run once on mount / when selectedStore changes
    const id = setInterval(tick, checkIntervalMs);
    return () => clearInterval(id);
  }, [selectedStore, triggerBranchClosedRevalidate]);

  const handleOpenSchedulingFromBanner = () => {
    if (!currentStoreForScheduling) return;
    setShowSchedulingDialog(true);
  };

  const handleSchedulingConfirmFromBanner = (schedulingData) => {
    if (!currentStoreForScheduling) {
      setShowSchedulingDialog(false);
      return;
    }

    const schedulingPayload = {
      ...schedulingData,
      storeId: currentStoreForScheduling.id,
    };

    dispatch(UpdateScheduledTime(schedulingPayload));
    setShowSchedulingDialog(false);
  };

  const getMenues = async () => {
    try {
      setLoading(true);
      const apiUrl = `${environment?.apiUrl}/getMenu?restaurantId=${environment?.restaurantId}`;

      const response = await fetchData(apiUrl, 'get');
      dispatch(res(response.data));

      if (storess?.length === 1) {
        const updatedUser = {
          ...userData,
          defaultStore: storess[0].id,
        };
        dispatch(setUser({ userData: updatedUser }));
        dispatch(menues(response.data[storess[0]?.id]?.menus));
      } else {
        const updatedUser = {
          ...userData,
          defaultStore: userData.defaultStore,
        };
        dispatch(setUser({ userData: updatedUser }));
        dispatch(menues(response.data[userData.defaultStore]?.menus));
      }
    } catch (error) {
      // error suppressed in production build
    }
    setLoading(false);
  };

  const getMenuFirebase = async () => {
    try {
      setLoading(true);
      let menusRef = firestore.collection('menus');
      menusRef = menusRef.where('is_deleted', '==', false);
      // Use the get method to retrieve all documents in the collection
      const querySnapshot = await menusRef.get();

      const mappedItems = querySnapshot.docs.map((d) => {
        return {
          id: d.id,
          ...d.data(),
        };
      });

      if (storess?.length === 1) {
        const updatedUser = {
          ...userData,
          defaultStore: storess[0].id,
        };
        dispatch(setUser({ userData: updatedUser }));
        const matchMenu = mappedItems.find(
          (item) =>
            item.store_ids?.includes(storess[0]?.id) ||
            item.store_id === storess[0]?.id
        );
        dispatch(menues([...matchMenu]));
      } else {
        const updatedUser = {
          ...userData,
          defaultStore: userData.defaultStore,
        };
        dispatch(setUser({ userData: updatedUser }));
        const matchMenu = mappedItems.find(
          (item) =>
            item.store_ids?.includes(userData.defaultStore) ||
            item.store_id === userData.defaultStore
        );
        dispatch(menues([...matchMenu]));
      }
    } catch (error) {
      // error suppressed in production build
    }
    setLoading(false);
  };
  const getModifierss = async () => {
    try {
      let modifiersRef = firestore.collection('modifier_groups');
      modifiersRef = modifiersRef.where('is_deleted', '==', false);
      let list = [];
      const modifierList = await modifiersRef.get();
      for (let index = 0; index < modifierList?.docs?.length; index++) {
        let element = modifierList?.docs[index]?.data();
        element.id = modifierList?.docs[index]?.id;
        list.push(element);
      }
      dispatch(setModifiers(list));
    } catch (err) {
      // error suppressed
    }
  };

  const getItems = async () => {
    try {
      // Build base query
      let ItemsRef = firestore.collection('items');
      ItemsRef = ItemsRef.where('is_deleted', '==', false);
      ItemsRef = ItemsRef.where('item_state', '==', 'available');

      // Try to have Firestore sort by defaultPrice (server-side) for efficiency.
      // If the field name differs or an index is required/missing, fall back
      // to client-side sorting to keep behavior stable.
      let itemsList = null;
      let usedServerSort = false;

      try {
        // First try camelCase field
        itemsList = await ItemsRef.orderBy('defaultPrice', 'desc').get();
        usedServerSort = true;
      } catch (errOrder) {
        // If ordering by camelCase failed, try snake_case
        try {
          itemsList = await ItemsRef.orderBy('default_price', 'desc').get();
          usedServerSort = true;
        } catch (errOrder2) {
          // Fall back to non-ordered query and sort client-side
          itemsList = await ItemsRef.get();
          usedServerSort = false;
        }
      }

      const mappedItems = itemsList.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));

      // If server-side ordering wasn't used (due to missing field/index), do client-side sort
      let finalList = mappedItems;
      if (!usedServerSort) {
        finalList = mappedItems.sort((a, b) => {
          const getPrice = (item) => {
            const v = item?.defaultPrice ?? item?.default_price ?? 0;
            const n =
              typeof v === 'string'
                ? parseFloat(v.replaceAll(',', ''))
                : Number(v);
            return isNaN(n) ? 0 : n;
          };
          return getPrice(b) - getPrice(a);
        });
      }

      dispatch(LoadItems([...finalList]));
    } catch (err) {
      // suppressed error
    }
  };

  const getCategories = async () => {
    try {
      const restaurantId = environment?.restaurantId;
      const isFattyPatty = restaurantId === 'fattyPatty';
      const isFattyPattyDev = restaurantId === 'fattyPattyDev';

      if (isFattyPattyDev) {
        let categoryRef = firestore.collection('categories');
        categoryRef = categoryRef.where('is_deleted', '==', false);
        categoryRef = categoryRef.where('enable_items', '==', true);

        const categoriesList = await categoryRef.get();
        const mappedItems = categoriesList.docs.map((d) => {
          return {
            id: d.id,
            ...d.data(),
          };
        });

        dispatch(LoadCategories(mappedItems));
        return;
      }

      let categoryRef = firestore.collection('categories');
      categoryRef = categoryRef.where('is_deleted', '==', false);
      categoryRef = categoryRef.where('enable_items', '==', true);
      if (isFattyPatty) {
        categoryRef = categoryRef.where('categoryType', '==', 'MENU_CATEGORY');
      }

      const categoriesList = await categoryRef.get();
      let mappedItems = categoriesList.docs.map((d) => {
        return {
          id: d.id,
          ...d.data(),
        };
      });

      // Do not include categories that have a channel with reference type FIRST_PARTY_INTEGRATION (e.g. Uber Eats)
      mappedItems = mappedItems.filter((c) => !hasFirstPartyIntegrationChannel(c));

      if (isFattyPatty) {
        const roots = mappedItems.filter(
          (c) =>
            c?.categoryType === 'MENU_CATEGORY' &&
            c?.is_top_level === true &&
            c?.online_visibility === true
        );
        const subs = mappedItems.filter(
          (c) =>
            c?.categoryType === 'MENU_CATEGORY' &&
            c?.rootCategory &&
            roots.some((r) => r.id === c.rootCategory)
        );
        const sampleChannelRefIds =
          mappedItems[0]?.channels
            ?.filter((ch) => ch?.reference?.type === 'LOCATION')
            ?.map((ch) => ch?.reference?.id) ?? [];
        console.log('[getCategories] FattyPatty', {
          total: mappedItems.length,
          roots: roots.length,
          rootIds: roots.map((r) => r.id),
          subs: subs.length,
          sampleCategoryId: mappedItems[0]?.id,
          sampleChannelRefIds,
        });
        dispatch(LoadCategories(mappedItems));
      } else {
        // For other environments, include popular category
        const popularCategory = {
          id: 'Popular',
          name: 'Popular',
          description: 'Popular',
          is_deleted: true,
          category_image_thumb_url: 'popularImage',
        };
        dispatch(LoadCategories([popularCategory, ...mappedItems]));
      }
    } catch (err) {
      // suppressed error
    }
  };

  const getStores = async () => {
    try {
      let storeRef = firestore.collection('stores');
      storeRef = storeRef.where('is_deleted', '==', false);
      let list = [];
      const StoresList = await storeRef.get();
      for (let index = 0; index < StoresList?.docs?.length; index++) {
        let element = StoresList?.docs[index]?.data();
        element.id = StoresList?.docs[index]?.id;
        list.push(element);
      }
      dispatch(setStores(list));
    } catch (err) {
      // suppressed error
    }
  };

  // Handle store selection and load menu data
  const handleStoreSelected = async (
    store,
    location,
    serviceType = null,
    preserveScheduledTime = false
  ) => {
    try {
      setSelectedStore(store);
      setUserLocation(location);
      setStoreId(store.id);
      setIsLoadingStoreMenu(true);

      // Clear scheduled time ONLY if it's for a different store AND not preserving
      if (!preserveScheduledTime) {
        if (
          scheduledTime &&
          scheduledTime.storeId &&
          scheduledTime.storeId !== store.id
        ) {
          dispatch(UpdateScheduledTime(null));
        }
      }

      // Update URL to include store ID for persistence
      const currentPath = window.location.pathname;
      const newPath = `/menu/store/${store.id}`;
      if (!currentPath.includes(`/store/${store.id}`)) {
        window.history.replaceState(null, '', newPath);
      }

      // Update user's default store if user is logged in
      if (userData?.uid) {
        await setUserDefaultStore(userData.uid, store.id);

        // Update Redux user data with selected service type
        const updatedUser = {
          ...userData,
          defaultStore: store.id,
          // Update pickupOrDelivery if a service type was selected from branch filter
          ...(serviceType &&
            serviceType !== 'none' && { pickupOrDelivery: serviceType }),
        };

        dispatch(setUser({ userData: updatedUser }));
      }

      // Fetch complete menu data for the selected store
      const menuData = await getCompleteMenuByStore(store.id);
      setStoreMenuData(menuData);

      // Update Redux with store-specific menu data (excluding modifiers - use global ones)
      dispatch(menues(menuData.menuItems));
    } catch (error) {
      // suppressed error logging
    } finally {
      setIsLoadingStoreMenu(false);
    }
  };

  // Handle location updates
  const handleLocationUpdate = (location) => {
    setUserLocation(location);
  };

  // Initialize anonymous session to ensure user document exists
  const initializeUserSession = async () => {
    if (isInitializingSession) return;

    try {
      setIsInitializingSession(true);

      // Check if user is already logged in
      if (user?.uid) {
        return;
      }

      // Initialize anonymous session with user's delivery preference
      // Use userData.pickupOrDelivery if available, otherwise default to 'pickup'
      const deliveryPreference = userData?.pickupOrDelivery || 'pickup';

      const result = await initializeAnonymousSession(deliveryPreference);
      if (result.success) {
      } else {
        // suppressed warning
      }
    } catch (error) {
      // suppressed error
    } finally {
      setIsInitializingSession(false);
    }
  };

  const handleNav = (direction) => {
    if (navRef.current) {
      // Get the first button to calculate width
      const firstButton = navRef.current.querySelector('button');
      if (firstButton) {
        // Calculate scroll amount: button width + gap
        const buttonWidth = firstButton.offsetWidth;
        const gap = 4; // matches the gap in the flex container
        const scrollAmount = buttonWidth + gap;

        if (direction === 'left') {
          navRef.current.scrollLeft -= scrollAmount;
        } else {
          navRef.current.scrollLeft += scrollAmount;
        }
      }
    }
  };

  const handleOpenn = () => {
    setId(id);
    setOpenn(true);
    setItem(item);
  };

  const handleClosee = () => {
    setOpenn(false);
  };

  const getStoreDelivery = async () => {
    if (user?.uid && user?.defaultDeliveryAddress != '')
      userAddresses?.map(async (a) => {
        if (a?.id === user?.defaultDeliveryAddress) {
          setStoreId(a?.delivery_store_id);
          storess?.filter((store) => {
            if (store?.id === a?.delivery_store_id) {
              setOutOfStockDelivery(store?.out_of_stock);
            }
          });
        }
      });
  };
  const getDefaults = async () => {
    try {
      setExtraquantity({});
      setDefs([]);
      const item = items?.filter((item) => item.id === id)[0];
      const mods = modifiers?.filter((mod) =>
        item?.modifier_group_ids?.includes(mod?.id)
      );

      const perimits = mods?.filter((opt) => opt?.minPermitted != 0);
      if (perimits) {
        let p = 0;
        let o = 0;
        for (const perimite of perimits) {
          for (const opt of perimite?.options) {
            if (opt.isDefault) {
              setOption(opt);
              setExtraquantity((ex) => ({
                ...ex,
                [perimite?.id]: [
                  {
                    customizationMeta: {},
                    defaultQuantity: opt?.minPermitted,
                    id: opt.id,
                    modifierTitle: opt.title,
                    price: opt.price,
                    quantity: 1,
                    title: perimite?.title,
                  },
                ],
              }));
              if (
                perimite?.minPermitted == 1 &&
                perimite?.maxPermittedUnique == 1
              ) {
                p = p + perimite?.options?.find((o) => o.isDefault)?.price;
              }
              if (
                perimite?.minPermitted > 0 &&
                perimite?.maxPermittedUnique != 1
              ) {
                o = o + opt?.price;
              }
              setDefs((defs) =>
                defs?.length
                  ? [...defs, [perimite?.title, opt.title]]
                  : [[perimite?.title, opt.title]]
              );
            }
          }
        }
        setOptionsPrice1(p > 0 ? p : 0);
      }
    } catch (err) {
      // suppressed error
    }
  };

  const getModifiers = async () => {
    setData(modifiers);
  };

  const handleOpen = (id, item) => {
    setId(id);
    setOpen(true);
    setItem(item);

    // Add name_slug to URL when opening dialog
    if (item?.name_slug) {
      const searchParams = new URLSearchParams(location.search);
      searchParams.set('name_slug', item.name_slug);
      navigate(`${location.pathname}?${searchParams.toString()}`, {
        replace: true,
      });
    }
  };

  const handleClose = () => {
    setOpen(false);
    setPendingEditCartItem(null);

    // Remove name_slug from URL when closing dialog
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.has('name_slug')) {
      searchParams.delete('name_slug');
      const newSearch = searchParams.toString();
      const newUrl = newSearch
        ? `${location.pathname}?${newSearch}`
        : location.pathname;
      navigate(newUrl, { replace: true });
    }
  };

  useEffect(() => {
    if (location?.state?.editCartItem) {
      setPendingEditCartItem(location.state.editCartItem);
      hasAppliedEditCartItemRef.current = false;
    }
  }, [location?.state?.editCartItem]);

  useEffect(() => {
    if (hasAppliedEditCartItemRef.current || !pendingEditCartItem) {
      return;
    }
    if (!Array.isArray(items) || items.length === 0) {
      return;
    }

    const menuItemToEdit = items.find(
      (menuItem) => menuItem?.id === pendingEditCartItem?.itemId
    );
    if (!menuItemToEdit) {
      return;
    }

    handleOpen(menuItemToEdit.id, menuItemToEdit);
    hasAppliedEditCartItemRef.current = true;
  }, [pendingEditCartItem, items]);

  const updateStickyCategoryNavPosition = useCallback(() => {
    const navEl = categoryStickyNavRef.current;
    if (!navEl) return;
    let bottom = 0;
    const headerEl = menuPageHeaderRef.current;
    if (headerEl) {
      bottom = Math.max(bottom, headerEl.getBoundingClientRect().bottom);
    }
    const scheduledEl = scheduledBannerRef.current;
    if (scheduledEl) {
      bottom = Math.max(bottom, scheduledEl.getBoundingClientRect().bottom);
    }
    const topPx = Math.max(0, Math.ceil(bottom));
    stickyCategoryNavTopRef.current = topPx;
    navEl.style.top = `${topPx}px`;
  }, []);

  const handleChangeType = async (value) => {
    if (
      smDown &&
      (environment?.restaurantId === 'fattyPattyDev' ||
        environment?.restaurantId === 'fattyPatty')
    ) {
      const sectionEl = categorySectionRefs.current?.[value];
      if (sectionEl && typeof window !== 'undefined') {
        isAutoScrollingCategoryRef.current = true;
        const stickyH = categoryStickyNavRef.current
          ? Math.ceil(
              categoryStickyNavRef.current.getBoundingClientRect().height
            )
          : mobileStickyCategoryNavHeight;
        const offset =
          stickyCategoryNavTopRef.current + stickyH + 8;
        const y =
          sectionEl.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({
          top: Math.max(0, y),
          behavior: 'smooth',
        });
        window.setTimeout(() => {
          isAutoScrollingCategoryRef.current = false;
        }, 900);
      }
    }
    setType(value);
  };

  // Mobile Fatty Patty: scroll the pill row horizontally only (avoids scrollIntoView moving the window).
  useEffect(() => {
    if (
      !smDown ||
      (environment?.restaurantId !== 'fattyPattyDev' &&
        environment?.restaurantId !== 'fattyPatty') ||
      !type ||
      !navRef.current
    ) {
      return;
    }
    const nav = navRef.current;
    const btn = Array.from(
      nav.querySelectorAll('[data-category-tab-id]')
    ).find((b) => b.getAttribute('data-category-tab-id') === type);
    if (!btn) return;
    const targetLeft =
      btn.offsetLeft - nav.clientWidth / 2 + btn.offsetWidth / 2;
    nav.scrollTo({
      left: Math.max(0, targetLeft),
      behavior: 'smooth',
    });
  }, [smDown, type, environment?.restaurantId]);

  useEffect(() => {
    getStoreDelivery();
  }, [outofStockDelivery]);

  // Initialize user session on component mount to prevent cart/address errors
  useEffect(() => {
    initializeUserSession();
  }, []);

  // Clear scheduled time if it's for a different store than currently selected
  // BUT preserve it if coming from navigation with preserveScheduledTime flag
  useEffect(() => {
    // Check if we're coming from navigation with explicit preserveScheduledTime
    const preserveScheduledTimeFromRoute =
      location?.state?.preserveScheduledTime || location?.state?.scheduledTime;

    // Only check after stores are loaded and we have a selected store or user default store
    const currentStoreId = selectedStore?.id || user?.defaultStore;

    // If navigation explicitly passed preserveScheduledTime, trust it and don't clear
    if (preserveScheduledTimeFromRoute) {
      return;
    }

    if (scheduledTime && scheduledTime.storeId && currentStoreId) {
      // If scheduled time is for a different store, clear it —
      // but skip if the cart still belongs to the scheduled store (user just logged in
      // and their defaultStore resolved to something different).
      if (scheduledTime.storeId !== currentStoreId && scheduledTime.storeId !== cartStoreId) {
        dispatch(UpdateScheduledTime(null));
      }
    }
  }, [selectedStore, user?.defaultStore, scheduledTime, location?.state, cartStoreId]);

  // Force fresh data fetch for fattyPattyDev on component mount
  useEffect(() => {
    if (
      environment?.restaurantId === 'fattyPattyDev' ||
      environment?.restaurantId === 'fattyPatty'
    ) {
      // Check if this is a page reload using performance API
      const isPageReload = performance.navigation.type === 1;
      const hasLoadedBefore = sessionStorage.getItem('fattyPattyDataLoaded');

      // Always force fresh data on reload or first load
      if (isPageReload || !hasLoadedBefore) {
        // Clear specific persisted data for fresh fetch
        persistor.purge().then(() => {
          // Force fresh data fetch after purge
          setTimeout(() => {
            setLoading(true);
            getStores();
            getMenuFirebase();
            getItems();
            getCategories();
            getModifierss();

            // Mark that we've loaded data for this session
            sessionStorage.setItem('fattyPattyDataLoaded', 'true');
          }, 100);
        });
      } else {
        // Check if we actually have data, if not, force fetch
        if (!categories || !items || !menuess || !storess) {
          setLoading(true);
          getStores();
          getMenuFirebase();
          getItems();
          getCategories();
          getModifierss();
        }
      }
    }
  }, []);

  // Handle store data passed from LocationDetails via router state or URL params
  useEffect(() => {
    const storeFromRoute = location?.state?.store;
    const storeIdFromParams = params?.storeId;
    const orderTypeFromRoute =
      location?.state?.orderType || location?.state?.preserveOrderType;
    const scheduledTimeFromRoute =
      location?.state?.scheduledTime || location?.state?.preserveScheduledTime;
    const preserveScheduledTime = location?.state?.preserveScheduledTime;

    // Priority: URL params > location state > auto-selection
    if (storeIdFromParams && !selectedStore) {
      // Find store by ID from URL params
      const storeFromParams = stores?.find(
        (store) => store.id === storeIdFromParams
      );
      if (storeFromParams) {
        handleStoreSelected(
          storeFromParams,
          null,
          orderTypeFromRoute,
          preserveScheduledTime
        );
        // Update URL to include store ID if not already present
        if (!window.location.pathname.includes(`/store/${storeIdFromParams}`)) {
          window.history.replaceState(
            null,
            '',
            `/menu/store/${storeIdFromParams}`
          );
        }
      } else if (stores?.length > 0) {
        // Store ID in URL is invalid, redirect to main menu
        window.history.replaceState(null, '', '/menu');
      }
    } else if (storeFromRoute && !selectedStore) {
      // Set the store as selected using the existing handler
      handleStoreSelected(
        storeFromRoute,
        null,
        orderTypeFromRoute,
        preserveScheduledTime
      );

      // Update URL to include store ID
      if (
        storeFromRoute.id &&
        !window.location.pathname.includes(`/store/${storeFromRoute.id}`)
      ) {
        window.history.replaceState(
          null,
          '',
          `/menu/store/${storeFromRoute.id}`
        );
      }
    }
  }, [location?.state?.store, selectedStore, params?.storeId, stores]);

  // Update Redux scheduledTime when coming from cart with preserveScheduledTime
  useEffect(() => {
    const preserveScheduledTimeFromRoute =
      location?.state?.preserveScheduledTime;

    if (preserveScheduledTimeFromRoute && location?.state?.fromCart) {
      dispatch(UpdateScheduledTime(preserveScheduledTimeFromRoute));
    }
  }, [
    location?.state?.preserveScheduledTime,
    location?.state?.fromCart,
    dispatch,
  ]);

  // Auto-open branch dialog when navigating from the Locations page via "Order Now"
  useEffect(() => {
    if (location?.state?.openBranchDialog) {
      setChangeBranchDialogOpen(true);
    }
  }, []);

  useEffect(() => {
    if (items?.length) {
      getDefaults();
    }
  }, [id, items?.length]);

  useEffect(() => {
    getModifiers();
    getModifierss();
  }, []);

  // Restore user's default store when cart is empty (avoid "no branch selected" then wrong branch)
  useEffect(() => {
    if (
      !stores?.length ||
      selectedStore ||
      location?.state?.store ||
      params?.storeId
    ) {
      return;
    }
    // If the user has a scheduled time, restore its store first so the banner is preserved.
    // Using the scheduled store takes priority over user.defaultStore to avoid clearing the time.
    if (scheduledTime?.storeId) {
      const scheduledStoreObj = stores.find((s) => s.id === scheduledTime.storeId);
      if (scheduledStoreObj) {
        handleStoreSelected(
          scheduledStoreObj,
          locationForNearestStore || hookUserLocation,
          null,
          true // preserveScheduledTime
        );
        return;
      }
    }
    if (user?.defaultStore) {
      const defaultStoreObj = stores.find((s) => s.id === user.defaultStore);
      if (defaultStoreObj) {
        handleStoreSelected(
          defaultStoreObj,
          locationForNearestStore || hookUserLocation
        );
      }
    }
  }, [
    stores,
    selectedStore,
    user?.defaultStore,
    location?.state?.store,
    params?.storeId,
    scheduledTime?.storeId,
  ]);

  // Auto-select store based on cart items first, then nearest store as fallback
  useEffect(() => {
    // Don't auto-select if there's already a store selected, or route/URL overrides exist
    if (
      selectedStore ||
      location?.state?.store ||
      params?.storeId ||
      (!hasUserCancelledDialog && showInitialBranchDialog)
    ) {
      return;
    }
    // When cart is empty and user has a default store, let the restore effect handle it (don't overwrite with nearest)
    if (user?.defaultStore && !cart?.length) {
      return;
    }

    let storeToSelect = null;

    // Priority 0: Scheduled time's store — if the user already has a scheduled time,
    // restore that store so the banner stays visible and no mismatch clear fires.
    if (scheduledTime?.storeId && stores?.length) {
      const scheduledStore = stores.find((s) => s.id === scheduledTime.storeId);
      if (scheduledStore) {
        storeToSelect = scheduledStore;
      }
    }

    // Priority 1: Cart store (if cart has items from a specific store)
    if (!storeToSelect && cartStore && cartStoreId) {
      storeToSelect = cartStore;
    }
    // Priority 2: Nearest store (fallback when no cart items)
    else if (!storeToSelect && nearestStore) {
      storeToSelect = nearestStore;
    }

    if (storeToSelect) {
      // Clear scheduled time if it exists and is for a different store
      if (
        scheduledTime &&
        scheduledTime.storeId &&
        scheduledTime.storeId !== storeToSelect.id
      ) {
        dispatch(UpdateScheduledTime(null));
      }

      handleStoreSelected(storeToSelect, hookUserLocation);
    }
  }, [
    cartStore,
    cartStoreId,
    nearestStore,
    selectedStore,
    location?.state?.store,
    params?.storeId,
    hasUserCancelledDialog,
    showInitialBranchDialog,
    user?.defaultStore,
    cart?.length,
    scheduledTime?.storeId,
    stores,
  ]);

  // Handle location updates (no UI)
  useEffect(() => {
    if (hookUserLocation) {
      handleLocationUpdate(hookUserLocation);
    }
  }, [hookUserLocation]);

  // Show initial branch selection dialog when stores are loaded and no store is pre-selected
  // BUT don't show if user already has a saved delivery address
  useEffect(() => {
    // Check if user has a saved delivery address
    const hasDeliveryAddress =
      user?.defaultDeliveryAddress &&
      userAddresses?.some((addr) => addr.id === user.defaultDeliveryAddress);

    // Try to find the address by ID
    let currentDeliveryAddress = userAddresses?.find(
      (a) => a.id === user?.defaultDeliveryAddress
    );

    // FALLBACK: If no match found but user has addresses, use the first one
    // This handles the case where defaultDeliveryAddress points to a deleted/missing address
    if (!currentDeliveryAddress && userAddresses && userAddresses.length > 0) {
      currentDeliveryAddress = userAddresses[0];
    }

    // Don't auto-open if user has any address (saved or from branch dialog - manual entry or "use my location")
    const hasAnyAddress =
      !!currentDeliveryAddressData || !!currentDeliveryAddress;
    const shouldOpen =
      stores?.length > 0 &&
      !selectedStore &&
      !location?.state?.store &&
      !params?.storeId &&
      !showInitialBranchDialog &&
      !hasUserCancelledDialog &&
      !hasAnyAddress &&
      // Don't prompt for store/time selection when the user already has a scheduled time —
      // they went through this process before login; showing the dialog again would clear it.
      !scheduledTime;

    if (shouldOpen) {
      setShowInitialBranchDialog(true);
    }
  }, [
    stores,
    selectedStore,
    location?.state?.store,
    params?.storeId,
    showInitialBranchDialog,
    hasUserCancelledDialog,
    user?.defaultDeliveryAddress,
    userAddresses,
    currentDeliveryAddressData,
    scheduledTime,
  ]);

  useEffect(() => {
    (async () => {
      if (params.id == null) {
        setOpen(false);
      } else {
        let item = items?.find((item) => item?.id === params?.id);
        handleOpen(item?.id, item);
      }
    })();
  }, [params.id]);

  useEffect(() => {
    if (
      environment?.restaurantId === 'ttJordanDev' ||
      environment?.restaurantId === 'ttJordan' ||
      environment?.restaurantId === 'fattyPattyDev' ||
      environment?.restaurantId === 'fattyPatty'
    ) {
      // Get the current store ID (same logic as filteredCategories/filteredItems)
      const currentStoreId = selectedStore?.id || user?.defaultStore;

      const isFattyPattyEnv =
        environment?.restaurantId === 'fattyPattyDev' ||
        environment?.restaurantId === 'fattyPatty';

      // Filter categories by store: FattyPatty uses menu/rootCategory + channels; others use channels or legacy store_ids
      let storeCategories;
      if (isFattyPattyEnv) {
        const rootIds = (categories || [])
          .filter(
            (c) =>
              c?.categoryType === 'MENU_CATEGORY' &&
              c?.is_top_level === true &&
              c?.online_visibility === true
          )
          .map((c) => c.id);
        storeCategories =
          categories?.filter((category) => {
            if (hasFirstPartyIntegrationChannel(category)) return false;
            const isRoot =
              category?.categoryType === 'MENU_CATEGORY' &&
              category?.is_top_level === true &&
              category?.online_visibility === true;
            const isSub =
              category?.categoryType === 'MENU_CATEGORY' &&
              category?.rootCategory &&
              rootIds.includes(category.rootCategory);
            if (!isRoot && !isSub) return false;
            return isCategoryAvailableAtStoreByChannels(
              category,
              currentStoreId
            );
          }) || [];
      } else {
        storeCategories =
          categories?.filter(
            (category) =>
              !hasFirstPartyIntegrationChannel(category) &&
              (category.id === 'Popular' ||
                (category.channels?.length
                  ? isCategoryAvailableAtStoreByChannels(category, currentStoreId)
                  : category.store_ids?.includes(currentStoreId) ||
                    category.store_id === currentStoreId))
          ) || [];
      }

      // Filter items by store (same logic as filteredItems)
      // Ensure storeItems is an array to avoid later crashes
      const storeItems =
        items?.filter((item) => {
          const belongsToStore =
            item.store_ids?.includes(currentStoreId) ||
            item.store_id === currentStoreId;
          const hasValidCategory = storeCategories.some(
            (category) => item.category_id === category.id
          );
          return belongsToStore && hasValidCategory;
        }) || [];

      const categoryItems = storeCategories?.filter((category) =>
        storeItems.find((item) => category.id === item.category_id)
      );

      if (!isFattyPattyEnv) {
        const popularItems = storeCategories?.filter((category) =>
          storeItems.find(
            (item) => category.id === item.category_id && item.is_popular
          )
        );

        // Determine desired initial selection (prefer Popular when available)
        const desiredInitial =
          popularItems?.length > 0 ? 'Popular' : categoryItems?.[0]?.id;

        // Only set type if there isn't already a valid selection
        if (
          desiredInitial &&
          (!type || !storeCategories?.some((c) => c.id === type))
        ) {
          setType(desiredInitial);
        }
      } else {
        // For fattyPatty environments, skip popular items and go directly to first category
        const desiredInitial = categoryItems?.[0]?.id;
        if (
          desiredInitial &&
          (!type || !storeCategories?.some((c) => c.id === type))
        ) {
          setType(desiredInitial);
        }
      }
      // }
    } else {
      menuess?.map((c) =>
        c.category_id?.map((category, index) => {
          if (index == 1 && c?.category_id[0]?.items_id?.length == 0) {
            const desired = c?.category_id[1]?.id;
            if (
              desired &&
              (!type || !orderedCategories?.some((cc) => cc.id === type))
            ) {
              setType(desired);
            }
          }
        })
      );
    }
  }, [menuess, categories, items, selectedStore, user?.defaultStore]);

  useEffect(() => {
    // For fattyPattyDev, skip this useEffect as we handle data loading in the mount useEffect
    if (
      environment?.restaurantId === 'fattyPattyDev' ||
      environment?.restaurantId === 'fattyPatty'
    ) {
      return;
    }

    // For other environments, use the existing logic
    if (menuess === undefined) {
      setLoading(true);
      if (
        environment?.restaurantId === 'ttJordanDev' ||
        environment?.restaurantId === 'ttJordan'
      ) {
        getMenuFirebase();
      } else {
        getMenues();
      }
    }
  }, [storess, menuess]);

  // Get the current store ID (either selected store or user's default store)
  const currentStoreId = selectedStore?.id || user?.defaultStore;

  // Filter categories by store_id or store_ids array (including Popular category for non-fattyPatty environments)
  const restaurantId = environment?.restaurantId;
  const isFattyPatty = restaurantId === 'fattyPatty';
  const isFattyPattyDev = restaurantId === 'fattyPattyDev';

  // First filter items by store to get all available items for this store
  // Default to empty array so downstream .some/.filter calls are safe
  const storeItems =
    items?.filter((item) => {
      return (
        item.store_ids?.includes(currentStoreId) ||
        item.store_id === currentStoreId
      );
    }) || [];

  // Filter categories that have available items in this store AND are currently available.
  // FattyPatty: only MENU_CATEGORY (root = is_top_level + online_visibility, sub = rootCategory), visibility by channels.
  // Others: visibility by channels if present, else legacy store_ids/store_id.
  const filteredCategories =
    categories?.filter((category) => {
      // Do not display categories that have FIRST_PARTY_INTEGRATION channel (e.g. Uber Eats)
      if (hasFirstPartyIntegrationChannel(category)) return false;

      // Branch/location visibility: channels (ACTIVE + reference.id = store) or legacy store_ids
      if (isFattyPatty) {
        const rootIds = (categories || [])
          .filter(
            (c) =>
              c?.categoryType === 'MENU_CATEGORY' &&
              c?.is_top_level === true &&
              c?.online_visibility === true
          )
          .map((c) => c.id);
        const isRoot =
          category?.categoryType === 'MENU_CATEGORY' &&
          category?.is_top_level === true &&
          category?.online_visibility === true;
        const isSub =
          category?.categoryType === 'MENU_CATEGORY' &&
          category?.rootCategory &&
          rootIds.includes(category.rootCategory);
        if (!isRoot && !isSub) return false;
        if (!isCategoryAvailableAtStoreByChannels(category, currentStoreId))
          return false;
      } else if (isFattyPattyDev) {
        if (category.channels?.length) {
          if (!isCategoryAvailableAtStoreByChannels(category, currentStoreId))
            return false;
        } else if (
          !category.store_ids?.includes(currentStoreId) &&
          category.store_id !== currentStoreId
        ) {
          return false;
        }
      } else {
        if (category.id !== 'Popular') {
          if (category.channels?.length) {
            if (!isCategoryAvailableAtStoreByChannels(category, currentStoreId))
              return false;
          } else if (
            !category.store_ids?.includes(currentStoreId) &&
            category.store_id !== currentStoreId
          ) {
            return false;
          }
        }
      }

      // Check if category has any items available in this store
      const hasItems = storeItems?.some((item) => {
        if (category.id === 'Popular') {
          return item.is_popular && item.item_state === 'available';
        }
        const directMatch =
          item.category_id === category.id && item.item_state === 'available';
        const arrayMatch =
          Array.isArray(item.category_ids) &&
          item.category_ids.includes(category.id) &&
          item.item_state === 'available';
        return directMatch || arrayMatch;
      });

      if (!hasItems) return false;

      // Availability periods (same logic as before), with fallback to child categories'
      // availability when this category has no explicit periods (common for menu parents
      // like \"Lunch Special\" whose children carry the time windows).
      const storeTimezone = selectedStore?.timezone || null;

      let periods =
        category.availability_periods || category.availabilityPeriods || [];

      // If this category has no explicit availability periods, try to derive them:
      // 1) from direct children (by parent_category.id or rootCategory)
      // 2) from its rootCategory (parent menu) if that has periods
      // 3) from \"sibling\" categories that share items via category_ids
      if (!periods || periods.length === 0) {
        const childPeriods =
          categories
            ?.filter(
              (c) =>
                c.id !== category.id &&
                (c?.parent_category?.id === category.id ||
                  c?.rootCategory === category.id)
            )
            .flatMap(
              (c) => c.availability_periods || c.availabilityPeriods || []
            ) || [];

        if (childPeriods.length > 0) {
          periods = childPeriods;
        } else if (category.rootCategory) {
          // Derive from the root/menu category's availability (e.g. Lunch Special root)
          const rootCategoryObj = categories?.find(
            (c) => c.id === category.rootCategory
          );
          const rootPeriods =
            rootCategoryObj?.availability_periods ||
            rootCategoryObj?.availabilityPeriods ||
            [];

          if (rootPeriods.length > 0) {
            periods = rootPeriods;
          }
        }

        if (!periods || periods.length === 0) {
          // Derive from related categories that share items via category_ids.
          // Example: items have category_ids including both this menu category id
          // and a leaf category that actually carries the time windows.
          const relatedCategoryIds = new Set();
          storeItems?.forEach((item) => {
            if (
              Array.isArray(item.category_ids) &&
              item.category_ids.includes(category.id)
            ) {
              item.category_ids.forEach((cid) => {
                if (cid !== category.id) {
                  relatedCategoryIds.add(cid);
                }
              });
            }
          });

          if (relatedCategoryIds.size > 0) {
            const relatedPeriods =
              categories
                ?.filter(
                  (c) =>
                    relatedCategoryIds.has(c.id) &&
                    ((c.availability_periods &&
                      c.availability_periods.length > 0) ||
                      (c.availabilityPeriods &&
                        c.availabilityPeriods.length > 0))
                )
                .flatMap(
                  (c) => c.availability_periods || c.availabilityPeriods || []
                ) || [];

            if (relatedPeriods.length > 0) {
              periods = relatedPeriods;
            }
          }
        }
      }

      const isAvailable = isCategoryAvailable(
        periods,
        storeTimezone,
        currentStoreId,
        scheduledTime
      );
      return isAvailable;
    }) || [];
  console.log('filteredCategories', filteredCategories);
  // Build ordered categories by grouping top-level with their children and sorting by ordinal ascending
  const orderedCategories = React.useMemo(() => {
    if (!filteredCategories || filteredCategories.length === 0) return [];

    const isFattyPattyEnv =
      environment?.restaurantId === 'fattyPattyDev' ||
      environment?.restaurantId === 'fattyPatty';

    // Separate out the special "Popular" category (only for non-fattyPatty envs)
    const popularCategory = !isFattyPattyEnv
      ? filteredCategories.find((c) => c?.id === 'Popular')
      : null;

    // Work only with real categories (exclude Popular from grouping/sorting)
    const realCategories = filteredCategories.filter(
      (c) => c?.id !== 'Popular'
    );

    // Helper to read ordinal safely; Square uses large negative numbers, smaller comes first
    const getOrdinal = (cat) =>
      cat?.parent_category && typeof cat.parent_category.ordinal === 'number'
        ? cat.parent_category.ordinal
        : 0;

    // Top-level categories:
    // - fattyPatty (prod): Square-style — leaf menu rows (is_top_level false + rootCategory) drive the nav.
    // - fattyPattyDev: same as other restaurants — roots are is_top_level === true (dev data often has no Square shape).
    // - Others: categories marked as is_top_level === true
    const useSquareFattyNav =
      environment?.restaurantId === 'fattyPatty';
    const topLevel = isFattyPattyEnv
      ? useSquareFattyNav
        ? realCategories
            .filter(
              (c) =>
                c?.categoryType === 'MENU_CATEGORY' &&
                c?.is_top_level === false &&
                !!c?.rootCategory
            )
            .sort((a, b) => getOrdinal(a) - getOrdinal(b))
        : realCategories
            .filter((c) => c?.is_top_level === true)
            .sort((a, b) => getOrdinal(a) - getOrdinal(b))
      : realCategories
          .filter((c) => c?.is_top_level === true)
          .sort((a, b) => getOrdinal(a) - getOrdinal(b));

    // Group children by parent: use rootCategory (menu id) when present, else parent_category.id
    const childrenByParentId = realCategories
      .filter(
        (c) =>
          c?.is_top_level === false &&
          (c?.rootCategory || c?.parent_category?.id)
      )
      .reduce((acc, c) => {
        const pid = c.rootCategory || c.parent_category.id;
        if (!acc[pid]) acc[pid] = [];
        acc[pid].push(c);
        return acc;
      }, {});

    // Sort each child list by ordinal
    Object.keys(childrenByParentId).forEach((pid) => {
      childrenByParentId[pid].sort((a, b) => getOrdinal(a) - getOrdinal(b));
    });

    // Build final ordered list: [Popular?] + for each top-level: top + its children
    const ordered = [];
    if (popularCategory) ordered.push(popularCategory);
    topLevel.forEach((top) => {
      ordered.push(top);
      const kids = childrenByParentId[top.id] || [];
      if (kids.length) ordered.push(...kids);
    });

    // If nothing was ordered but we still have categories (e.g. missing is_top_level flags), show them flat.
    if (ordered.length === 0 && realCategories.length > 0) {
      return [...realCategories].sort((a, b) => getOrdinal(a) - getOrdinal(b));
    }

    return ordered;
  }, [filteredCategories, environment?.restaurantId]);

  // Debug: log category pipeline (currentStoreId, counts at each filter step)
  useEffect(() => {
    const isFattyPattyEnv =
      environment?.restaurantId === 'fattyPattyDev' ||
      environment?.restaurantId === 'fattyPatty';
    const sid = selectedStore?.id || user?.defaultStore;
    const storeItemsCount =
      items?.filter(
        (item) => item.store_ids?.includes(sid) || item.store_id === sid
      )?.length ?? 0;

    if (!categories?.length) return;

    if (isFattyPattyEnv) {
      const rootIds = (categories || [])
        .filter(
          (c) =>
            c?.categoryType === 'MENU_CATEGORY' &&
            c?.is_top_level === true &&
            c?.online_visibility === true
        )
        .map((c) => c.id);
      const rootOrSub = categories.filter((c) => {
        const isRoot =
          c?.categoryType === 'MENU_CATEGORY' &&
          c?.is_top_level === true &&
          c?.online_visibility === true;
        const isSub =
          c?.categoryType === 'MENU_CATEGORY' &&
          c?.rootCategory &&
          rootIds.includes(c.rootCategory);
        return isRoot || isSub;
      });
      const passChannel = rootOrSub.filter((c) =>
        isCategoryAvailableAtStoreByChannels(c, sid)
      );
      const storeItemsHere =
        items?.filter(
          (item) => item.store_ids?.includes(sid) || item.store_id === sid
        ) ?? [];
      const passItems = passChannel.filter((c) =>
        storeItemsHere.some(
          (item) => item.category_id === c.id && item.item_state === 'available'
        )
      );
      const storeTz = selectedStore?.timezone || null;
      const passAvailability = passItems.filter((c) =>
        isCategoryAvailable(
          c.availability_periods || c.availabilityPeriods || [],
          storeTz,
          sid,
          scheduledTime
        )
      );
      // keep local variables for potential future debugging
      void passAvailability;
    }
  }, [
    categories,
    items,
    selectedStore,
    user?.defaultStore,
    scheduledTime,
    filteredCategories?.length,
    orderedCategories?.length,
    environment?.restaurantId,
  ]);

  // Auto-select the first category when orderedCategories changes
  useEffect(() => {
    if (
      orderedCategories?.length > 0 &&
      (!type || !orderedCategories.some((cat) => cat.id === type))
    ) {
      setType(orderedCategories[0].id);
    }
  }, [orderedCategories, type]);

  // Mobile Fatty Patty: sync active category chip with visible section while scrolling
  useEffect(() => {
    const shouldAutoSyncCategory =
      smDown &&
      (environment?.restaurantId === 'fattyPattyDev' ||
        environment?.restaurantId === 'fattyPatty');

    if (!shouldAutoSyncCategory || !orderedCategories?.length) {
      return;
    }

    const sectionElements = orderedCategories
      .map((category) => ({
        id: category.id,
        el: categorySectionRefs.current?.[category.id],
      }))
      .filter((entry) => !!entry.el);

    if (sectionElements.length === 0) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (isAutoScrollingCategoryRef.current) {
          return;
        }

        const navTop = stickyCategoryNavTopRef.current;
        const stickyH =
          (categoryStickyNavRef.current &&
            Math.ceil(
              categoryStickyNavRef.current.getBoundingClientRect().height
            )) ||
          mobileStickyCategoryNavHeight;
        const stickySnap = navTop + stickyH + 8;

        const visibleEntries = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => {
            const topA = a.boundingClientRect.top;
            const topB = b.boundingClientRect.top;
            return (
              Math.abs(topA - stickySnap) - Math.abs(topB - stickySnap)
            );
          });

        if (!visibleEntries.length) {
          return;
        }

        const activeSectionId = visibleEntries[0].target.getAttribute(
          'data-category-id'
        );
        if (!activeSectionId) return;

        if (categoryObserverDebounceRef.current) {
          clearTimeout(categoryObserverDebounceRef.current);
        }
        categoryObserverDebounceRef.current = setTimeout(() => {
          categoryObserverDebounceRef.current = null;
          setType((prev) =>
            activeSectionId !== prev ? activeSectionId : prev
          );
        }, 140);
      },
      {
        root: null,
        rootMargin: `-12% 0px -62% 0px`,
        threshold: [0, 0.1, 0.25],
      }
    );

    sectionElements.forEach(({ el }) => observer.observe(el));

    return () => {
      if (categoryObserverDebounceRef.current) {
        clearTimeout(categoryObserverDebounceRef.current);
        categoryObserverDebounceRef.current = null;
      }
      observer.disconnect();
    };
  }, [smDown, orderedCategories, mobileStickyCategoryNavHeight]);

  useLayoutEffect(() => {
    const isFatty =
      environment?.restaurantId === 'fattyPattyDev' ||
      environment?.restaurantId === 'fattyPatty';
    if (!smDown || !isFatty || !categoryStickyNavRef.current) {
      return;
    }
    const el = categoryStickyNavRef.current;
    const measure = () => {
      const h = Math.ceil(el.getBoundingClientRect().height);
      if (h > 0) {
        setMobileStickyCategoryNavHeight(h);
      }
    };
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, [
    smDown,
    environment?.restaurantId,
    orderedCategories,
    type,
    storeItems?.length,
    filteredCategories?.length,
  ]);

  // Periodic refresh for category availability (check every minute)
  const [availabilityRefresh, setAvailabilityRefresh] = useState(0);

  useEffect(() => {
    // Only set up refresh if we have categories with availability periods
    const hasAvailabilityPeriods = categories?.some(
      (category) =>
        category.availabilityPeriods && category.availabilityPeriods.length > 0
    );

    if (!hasAvailabilityPeriods) return;

    const interval = setInterval(() => {
      setAvailabilityRefresh((prev) => prev + 1);
    }, 60000); // Refresh every minute

    return () => clearInterval(interval);
  }, [categories]);

  // Debug: log why each category is displayed or hidden (set DEBUG_CATEGORY_DISPLAY = true at top of file)
  useEffect(() => {
    if (!DEBUG_CATEGORY_DISPLAY || !categories?.length) return;

    const storeItemsForDebug =
      items?.filter(
        (item) =>
          item.store_ids?.includes(currentStoreId) ||
          item.store_id === currentStoreId
      ) || [];
    const storeTz = selectedStore?.timezone || null;
    const sid = currentStoreId;
    let displayed = 0;
    let hidden = 0;

    console.debug(
      '[Category display] Store:',
      sid || 'none',
      '| Timezone:',
      storeTz || 'none (using local)',
      '| Scheduled:',
      scheduledTime?.dateOfOrder ? 'yes' : 'no'
    );

    for (const category of categories) {
      const hasItems = storeItemsForDebug.some((item) => {
        if (category.id === 'Popular') {
          return item.is_popular && item.item_state === 'available';
        }
        return (
          item.category_id === category.id && item.item_state === 'available'
        );
      });

      const periods =
        category.availability_periods || category.availabilityPeriods || [];
      const { available, reason, timeWindows } = getCategoryAvailabilityDebug(
        periods,
        storeTz,
        sid,
        scheduledTime
      );
      const inFiltered = hasItems && available;
      const windowStr = formatTimeWindows(timeWindows);

      if (inFiltered) {
        displayed += 1;
        const parts = [
          `DISPLAYED: "${category.name}" (${category.id}) — Has ≥1 available item. ${reason}`,
        ];
        if (timeWindows.length > 0) {
          parts.push(`Time-gated: only during ${windowStr}.`);
        }
        console.debug('[Category display]', parts.join(' '));
      } else {
        hidden += 1;
        const parts = [`NOT DISPLAYED: "${category.name}" (${category.id}) —`];
        if (!hasItems) {
          parts.push('No available items in this store for this category.');
        } else {
          parts.push(`Has items but ${reason}.`);
          if (windowStr) parts.push(`Would show during: ${windowStr}.`);
        }
        console.debug('[Category display]', parts.join(' '));
      }
    }

    console.debug(
      '[Category display] Total: displayed',
      displayed,
      '| hidden',
      hidden
    );
  }, [
    categories,
    items,
    currentStoreId,
    selectedStore,
    scheduledTime,
    availabilityRefresh,
  ]);

  // Filter items by BOTH store and category.
  // FattyPatty: items can belong to menu categories via category_ids as well as category_id.
  const filteredItems = React.useMemo(() => {
    if (!storeItems?.length || !filteredCategories?.length) return [];

    const categoryIdSet = new Set(filteredCategories.map((c) => c.id));

    const result = storeItems.filter((item) => {
      const directMatch = categoryIdSet.has(item.category_id);
      const arrayMatch =
        Array.isArray(item.category_ids) &&
        item.category_ids.some((id) => categoryIdSet.has(id));

      return isFattyPatty || isFattyPattyDev
        ? directMatch || arrayMatch
        : directMatch;
    });
    return result;
  }, [storeItems, filteredCategories, isFattyPatty, isFattyPattyDev]);

  const popularItems = filteredItems?.filter((item) => item.is_popular);

  // Helper to get current location display with fallback (saved addresses only)
  const currentLocation =
    userAddresses?.find((a) => a.id === user?.defaultDeliveryAddress) ||
    (userAddresses && userAddresses.length > 0 ? userAddresses[0] : null);
  // Pass last-selected address to branch dialog: from branch menu (manual or "use my location") or saved
  const savedDeliveryAddressForDialog =
    currentDeliveryAddressData || currentLocation;

  const showMobileStickyCategoryNav =
    smDown &&
    (environment?.restaurantId === 'fattyPattyDev' ||
      environment?.restaurantId === 'fattyPatty') &&
    (filteredItems?.length ?? 0) > 0;

  // Keep fixed category pills directly under the menu SectionHeader while it is on-screen
  useLayoutEffect(() => {
    if (!showMobileStickyCategoryNav) return;

    updateStickyCategoryNavPosition();

    let raf = 0;
    const schedule = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        updateStickyCategoryNavPosition();
      });
    };

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);

    const headerEl = menuPageHeaderRef.current;
    const scheduledEl = scheduledBannerRef.current;
    let ro;
    if (typeof ResizeObserver !== 'undefined') {
      ro = new ResizeObserver(schedule);
      if (headerEl) ro.observe(headerEl);
      if (scheduledEl) ro.observe(scheduledEl);
    }

    return () => {
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      if (ro) ro.disconnect();
      if (raf) cancelAnimationFrame(raf);
    };
  }, [
    showMobileStickyCategoryNav,
    updateStickyCategoryNavPosition,
    scheduledTime?.dateOfOrder,
  ]);

  return (
    <>
      {environment?.restaurantId === 'istanbulDk' && (
        <Helmet>
          <title>Taqwa's Bakery and Restaurant | Menu</title>
        </Helmet>
      )}
      {environment?.restaurantId === 'ttJordanDev' && (
        <Helmet>
          <title>Taqwa's Bakery and Restaurant | Menu</title>
        </Helmet>
      )}
      {environment?.restaurantId === 'fattyPattyDev' && (
        <Helmet>
          <title>fattyPattyDev | Menu</title>
        </Helmet>
      )}
      {environment?.restaurantId === 'fattyPatty' && (
        <Helmet>
          <title>fatty Patty | Menu</title>
        </Helmet>
      )}
      {environment?.restaurantId === 'ttJordan' && (
        <Helmet>
          <title>Filfil jordan</title>
        </Helmet>
      )}
      <Box
        sx={{
          backgroundColor:
            environment?.restaurantId === 'fattyPattyDev' ||
            environment?.restaurantId === 'fattyPatty'
              ? '#f3f3f3'
              : 'transparent',
          minHeight: stableHeight,
          pb: 5,
        }}
      >
        {environment?.restaurantId === 'fattyPattyDev' ||
        environment?.restaurantId === 'fattyPatty' ? (
          <Box
            ref={menuPageHeaderRef}
            sx={{
              position: 'relative',
              zIndex: smDown ? 1101 : undefined,
            }}
          >
          <SectionHeader
            title="Menu"
            breadcrumbs={[
              { label: 'Home', path: '/' },
              { label: 'menu', current: true },
            ]}
            fontFamily="Jost"
            showBreadcrumbs={true}
            titleVariant="h2"
            customStyles={{
              title: { fontSize: '40px', fontWeight: '700' },
              container: { minHeight: '250px' },
            }}
            showChangeButton={true}
            changeButtonLabel="Change"
            onChangeClick={() => setChangeBranchDialogOpen(true)}
            changeButtonContent={
              <Typography
                sx={{
                  fontWeight: 700,
                  color: '#172B4D',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  fontFamily: '"Jost", sans-serif',
                }}
              >
                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.4963 11.121V19.5C20.4963 20.0304 20.2856 20.5391 19.9105 20.9142C19.5355 21.2893 19.0268 21.5 18.4963 21.5H6.50433C5.97407 21.4997 5.46562 21.2889 5.09076 20.9139C4.71591 20.5388 4.50533 20.0303 4.50533 19.5V11.121M8.00233 9.25L8.50233 3.5M8.00233 9.25C8.00233 12.152 12.5003 12.152 12.5003 9.25M8.00233 9.25C8.00233 12.426 2.84733 11.77 3.56933 9.002L4.61433 4.995C4.72601 4.56703 4.97641 4.18815 5.32635 3.91765C5.67629 3.64714 6.10603 3.50026 6.54833 3.5H18.4523C18.8946 3.50026 19.3244 3.64714 19.6743 3.91765C20.0243 4.18815 20.2747 4.56703 20.3863 4.995L21.4313 9.002C22.1533 11.771 16.9983 12.426 16.9983 9.25M12.5003 9.25V3.5M12.5003 9.25C12.5003 12.152 16.9983 12.152 16.9983 9.25M16.9983 9.25L16.4983 3.5"
                    stroke="#172B4D"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>

                {selectedStore ? (
                  <>{selectedStore.businessName || selectedStore.name}</>
                ) : (
                  'Select Location'
                )}
              </Typography>
            }
          />
          </Box>
        ) : (
          <div
            style={{
              position: 'relative',
              width: '100%',
              height: '450px',
              backgroundImage:
                environment.restaurantId === 'alyousef'
                  ? `url(${menuAlyosef})`
                  : environment.restaurantId === 'filfil'
                  ? `url(${TableTuck})`
                  : environment.restaurantId === 'ttDemo'
                  ? `url(${MenuTTdemo})`
                  : environment.restaurantId === 'istanbulDk'
                  ? `url(${banner})`
                  : environment.restaurantId === 'ttJordanDev'
                  ? `url(${ttjordanbanner})`
                  : environment.restaurantId === 'fattyPattyDev'
                  ? `url(${ttjordanbanner})`
                  : environment.restaurantId === 'fattyPatty'
                  ? `url(${ttjordanbanner})`
                  : environment.restaurantId === 'ttJordan'
                  ? `url(${ttjordanbanner})`
                  : `url(${reviewschool})`,

              backgroundRepeat: 'no-repeat',
            }}
          ></div>
        )}

        {/* Scheduled / ASAP Time Banner */}
        {scheduledTime && (scheduledTime.dateOfOrder || scheduledTime.isAsap) && (
          <Container ref={scheduledBannerRef} maxWidth={smDown ? 'sm' : 'lg'}>
            <Box
              sx={{
                mt: 3,
                mb: 3,
                mx: 'auto',
                maxWidth: smDown ? '100%' : '800px',
                backgroundColor: '#fff',
                borderRadius: '16px',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                border: `2px solid ${environment.mainColor}30`,
                overflow: 'hidden',
                position: 'relative',
                animation: 'slideDown 0.5s ease-out',
                '@keyframes slideDown': {
                  from: {
                    opacity: 0,
                    transform: 'translateY(-20px)',
                  },
                  to: {
                    opacity: 1,
                    transform: 'translateY(0)',
                  },
                },
              }}
            >
              {/* Top accent bar */}
              <Box
                sx={{
                  height: '6px',
                  background: `linear-gradient(90deg, ${environment.mainColor} 0%, ${environment.mainColor}80 100%)`,
                }}
              />

              <Box
                sx={{
                  p: { xs: 2, sm: 3 },
                  display: 'flex',
                  alignItems: { xs: 'flex-start', sm: 'center' },
                  justifyContent: 'space-between',
                  gap: 2,
                  flexWrap: 'wrap',
                }}
              >
                {/* Icon and Info Section */}
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: { xs: 1.5, sm: 2.5 },
                    flex: 1,
                  }}
                >
                  {/* Animated Icon */}
                  <Box
                    sx={{
                      width: { xs: '48px', sm: '56px' },
                      height: { xs: '48px', sm: '56px' },
                      borderRadius: '50%',
                      backgroundColor: `${environment.mainColor}15`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                      animation: 'pulse 2s infinite',
                      '@keyframes pulse': {
                        '0%, 100%': {
                          boxShadow: `0 0 0 0 ${environment.mainColor}40`,
                        },
                        '50%': {
                          boxShadow: `0 0 0 8px ${environment.mainColor}10`,
                        },
                      },
                    }}
                  >
                    {scheduledTime.isAsap ? (
                      <MdFlashOn
                        size={smDown ? 24 : 28}
                        style={{ color: environment.mainColor }}
                      />
                    ) : (
                      <MdSchedule
                        size={smDown ? 24 : 28}
                        style={{ color: environment.mainColor }}
                      />
                    )}
                  </Box>

                  {/* Text Content */}
                  <Box sx={{ flex: 1 }}>
                    <Typography
                      sx={{
                        fontSize: { xs: '11px', sm: '12px' },
                        fontWeight: 600,
                        color: environment.mainColor,
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        fontFamily: 'Jost',
                        mb: 0.5,
                      }}
                    >
                      {scheduledTime.isAsap ? 'ASAP Order' : 'Scheduled Order'}
                    </Typography>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'baseline',
                        gap: 1,
                        flexWrap: 'wrap',
                      }}
                    >
                      {scheduledTime.isAsap ? (
                        <>
                          <Typography
                            sx={{
                              fontSize: { xs: '15px', sm: '18px' },
                              fontWeight: 700,
                              color: '#1a1a1a',
                              fontFamily: 'Jost',
                              lineHeight: 1.2,
                            }}
                          >
                            As Soon As Possible
                          </Typography>
                        </>
                      ) : (
                        <>
                          <Typography
                            sx={{
                              fontSize: { xs: '15px', sm: '18px' },
                              fontWeight: 700,
                              color: '#1a1a1a',
                              fontFamily: 'Jost',
                              lineHeight: 1.2,
                            }}
                          >
                            {scheduledTime.sendTime === 'today'
                              ? 'Today'
                              : scheduledTime.sendTime === 'tomorrow'
                              ? 'Tomorrow'
                              : scheduledTime.sendTime}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: { xs: '13px', sm: '15px' },
                              fontWeight: 600,
                              color: '#4B5563',
                              fontFamily: 'Jost',
                            }}
                          >
                            at {scheduledTime.displayTime || 'N/A'}
                          </Typography>
                          {(scheduledTime?.dateOfOrder || scheduledTime?.date) && (
                            <Typography
                              sx={{
                                fontSize: { xs: '12px', sm: '13px' },
                                color: '#6B7280',
                                fontFamily: 'Jost',
                                mt: 0.25,
                              }}
                            >
                              {(() => {
                                const date = new Date(
                                  scheduledTime.dateOfOrder || scheduledTime.date
                                );
                                const weekday = date.toLocaleDateString(undefined, {
                                  weekday: 'short',
                                });
                                const monthDay = date.toLocaleDateString(
                                  undefined,
                                  {
                                    month: 'short',
                                    day: 'numeric',
                                  }
                                );
                                return `${weekday}, ${monthDay}`;
                              })()}
                            </Typography>
                          )}
                        </>
                      )}
                    </Box>
                    {scheduledTime.isAsap ? (
                      <Typography
                        sx={{
                          fontSize: { xs: '11px', sm: '12px' },
                          color: '#6B7280',
                          fontFamily: 'Jost',
                          mt: 0.5,
                        }}
                      >
                        {user?.pickupOrDelivery === 'delivery'
                          ? 'Your order will be delivered approximately within 45 min - 1 hour'
                          : 'Your order will be ready for pickup approximately within 15 minutes'}
                      </Typography>
                    ) : user?.pickupOrDelivery === 'delivery' ? (
                      <Typography
                        sx={{
                          fontSize: { xs: '11px', sm: '12px' },
                          color: '#6B7280',
                          fontFamily: 'Jost',
                          mt: 0.5,
                          lineHeight: 1.3,
                        }}
                      >
                        An additional 45 min - 1 hour will be added to your
                        scheduled time to ensure fresh delivery
                      </Typography>
                    ) : (
                      <Typography
                        sx={{
                          fontSize: { xs: '11px', sm: '12px' },
                          color: '#6B7280',
                          fontFamily: 'Jost',
                          mt: 0.5,
                        }}
                      >
                        Your order will be ready for pickup at the selected time
                      </Typography>
                    )}
                  </Box>
                </Box>

                {/* Actions */}
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                    flex: { xs: '0 0 100%', sm: '0 0 auto' },
                    justifyContent: { xs: 'center', sm: 'flex-end' },
                    mt: { xs: 1, sm: 0 },
                  }}
                >
                  <Button
                    onClick={handleOpenSchedulingFromBanner}
                    sx={{
                      borderRadius: '999px',
                      textTransform: 'none',
                      fontFamily: 'Jost',
                      fontWeight: 600,
                      px: 2.5,
                      py: 1,
                      fontSize: { xs: '12px', sm: '14px' },
                      background: `linear-gradient(90deg, ${environment.mainColor} 0%, ${environment.mainColor}CC 100%)`,
                      color: '#ffffff',
                      boxShadow: `0 8px 16px ${environment.mainColor}40`,
                      '&:hover': {
                        background: `linear-gradient(90deg, ${environment.mainColor}CC 0%, ${environment.mainColor} 100%)`,
                        boxShadow: `0 12px 24px ${environment.mainColor}55`,
                      },
                    }}
                    aria-label="Change scheduled time"
                    startIcon={scheduledTime.isAsap ? <MdFlashOn size={18} /> : <MdSchedule size={18} />}
                  >
                    {scheduledTime.isAsap ? 'Change to scheduled' : 'Change time'}
                  </Button>
                </Box>
              </Box>
            </Box>
          </Container>
        )}

        {!environment?.restaurantId === 'fattyPattyDev' &&
          !environment?.restaurantId === 'fattyPatty' && (
            <Container maxWidth={'lg'}>
              <Grid
                container
                style={{
                  display: smDown ? 'unset' : 'flex',
                  justifyContent: 'center',
                }}
              >
                <Typography
                  variant={smDown ? 'h4' : 'h2'}
                  style={{
                    marginTop: '30px',
                    fontFamily: `Hanalei Fill, cursive`,
                    marginBottom: '20px',
                    color: environment.mainColor,
                    fontWeight: 'bold',
                    textAlign: 'center',
                  }}
                >
                  {t('menu.ChooseOurMenu')}
                </Typography>
              </Grid>
            </Container>
          )}

        {/* Location and Store Selector Logic - Running in background */}
        {/* <Container maxWidth="lg" sx={{ mt: 2, mb: 3 }}>
          <LocationStoreSelector
            onStoreSelected={handleStoreSelected}
            onLocationUpdate={handleLocationUpdate}
            autoSelectNearest={!location?.state?.store} // Only auto-select nearest if we didn't navigate from a specific store
            showLocationInput={true}
            showStoreSelector={true}
            compact={false}
            collapsible={true}
            initialExpanded={!selectedStore}
            enableConsoleLogging={false}
          />
        </Container> */}
        {/* Show loading state while menu is being loaded */}
        {isLoadingStoreMenu && (
          <Container maxWidth="lg" sx={{ textAlign: 'center', py: 4 }}>
            <Loading loading={true} background="transparent" />
            <Typography variant="h6" sx={{ mt: 2, color: 'text.secondary' }}>
              Loading menu for {selectedStore?.businessName}...
            </Typography>
          </Container>
        )}

        {/* Show menu content only when store is selected and not loading */}
        {selectedStore && !isLoadingStoreMenu && (
          <>
            {showMobileStickyCategoryNav ? (
              <Box
                ref={categoryStickyNavRef}
                sx={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  right: 0,
                  zIndex: 1100,
                  backgroundColor: '#f3f3f3',
                  borderBottom: '1px solid #e6e6e6',
                  pt: 'max(10px, env(safe-area-inset-top, 0px))',
                  pb: 1,
                  boxShadow: '0 4px 14px rgba(0,0,0,0.07)',
                }}
              >
                <Box
                  sx={{
                    maxWidth: 900,
                    mx: 'auto',
                    px: { xs: 1.25, sm: 2.5 },
                    display: 'flex',
                    alignItems: 'center',
                    position: 'relative',
                  }}
                >
                  {orderedCategories?.length > (smDown ? 2 : 5) && (
                    <button
                      type="button"
                      onClick={() => handleNav('left')}
                      style={{
                        position: 'absolute',
                        left: 4,
                        background: '#fff',
                        border: '1px solid #e0e0e0',
                        borderRadius: '50%',
                        width: '35px',
                        height: '35px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        zIndex: 2,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                      }}
                    >
                      <KeyboardDoubleArrowLeftTwoToneIcon fontSize="small" />
                    </button>
                  )}

                  <Box
                    component="div"
                    ref={navRef}
                    sx={{
                      display: 'flex',
                      backgroundColor: '#FFFFFF',
                      borderRadius: '48px',
                      p: '6px',
                      overflowX: 'auto',
                      scrollBehavior: 'smooth',
                      flex: 1,
                      mx: orderedCategories?.length > 6 ? 0 : 'auto',
                      gap: '4px',
                      scrollbarWidth: 'none',
                      msOverflowStyle: 'none',
                      '&::-webkit-scrollbar': { display: 'none' },
                    }}
                  >
                    {orderedCategories.map((category) => (
                      <button
                        key={category.id}
                        type="button"
                        data-category-tab-id={category.id}
                        onClick={() => {
                          handleChangeType(category.id);
                          setEnableAdd(false);
                        }}
                        style={{
                          padding: '8px 24px',
                          backgroundColor:
                            type === category?.id
                              ? environment.mainColor
                              : 'transparent',
                          color: type === category?.id ? '#ffffff' : '#000000',
                          border: 'none',
                          borderRadius: '32px',
                          fontSize: '13px',
                          fontWeight: 700,
                          fontFamily: '"Jost", sans-serif',
                          cursor: 'pointer',
                          whiteSpace: 'nowrap',
                          minWidth: 'fit-content',
                          transition: 'background-color 0.2s ease, color 0.2s ease',
                          textTransform: 'capitalize',
                          boxShadow:
                            type === category?.id
                              ? '0 2px 8px rgba(248, 153, 53, 0.3)'
                              : 'none',
                          textShadow:
                            type === category?.id
                              ? '0 1px 3px rgba(0, 0, 0, 0.3)'
                              : 'none',
                        }}
                      >
                        {category.name}
                      </button>
                    ))}
                  </Box>

                  {orderedCategories?.length > (smDown ? 2 : 5) && (
                    <button
                      type="button"
                      onClick={() => handleNav('right')}
                      style={{
                        position: 'absolute',
                        right: 4,
                        background: '#fff',
                        border: '1px solid #e0e0e0',
                        borderRadius: '50%',
                        width: '35px',
                        height: '35px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        zIndex: 2,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                      }}
                    >
                      <KeyboardDoubleArrowRightTwoToneIcon fontSize="small" />
                    </button>
                  )}
                </Box>
              </Box>
            ) : null}
            <div className="menu-container ">
              {/* Check if no data is available across all restaurants */}
              {filteredCategories?.length === 0 &&
              filteredItems?.length === 0 ? (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '60vh',
                    width: '100%',
                    padding: '40px 20px',
                    background: 'none',
                  }}
                >
                  <img
                    src={noItems}
                    alt="No menu items available"
                    loading="lazy"
                    decoding="async"
                    style={{
                      maxWidth: '300px',
                      width: '100%',
                      height: 'auto',
                      marginBottom: '32px',
                      opacity: 0.8,
                    }}
                  />
                  <Typography
                    variant="h4"
                    style={{
                      fontWeight: 700,
                      marginBottom: '16px',
                      fontFamily: 'Jost, sans-serif',
                      textAlign: 'center',
                      fontSize: '28px',
                      color: environment?.mainColor || '#172B4D',
                    }}
                  >
                    No Menu Available 🍽️
                  </Typography>
                  <Typography
                    variant="body1"
                    style={{
                      color: '#828282',
                      textAlign: 'center',
                      fontSize: '16px',
                      maxWidth: '400px',
                      lineHeight: 1.6,
                    }}
                  >
                    We're currently updating our menu. Please check back later
                    for delicious options!
                  </Typography>
                </div>
              ) : environment?.restaurantId === 'fattyPattyDev' ||
                environment?.restaurantId === 'fattyPatty' ? (
                showMobileStickyCategoryNav ? (
                  <div
                    aria-hidden
                    style={{
                      width: '100%',
                      minHeight: mobileStickyCategoryNavHeight,
                      flexShrink: 0,
                    }}
                  />
                ) : (
                <div
                  style={{
                    width: '100%',
                    padding: '20px 0',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    overflow: 'hidden',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      position: 'relative',
                      maxWidth: '900px',
                      width: '100%',
                      padding: '0 20px',
                      margin: '0 auto',
                    }}
                  >
                    {orderedCategories?.length > (smDown ? 2 : 5) && (
                      <button
                        type="button"
                        onClick={() => handleNav('left')}
                        style={{
                          position: 'absolute',
                          left: '0',
                          background: '#fff',
                          border: '1px solid #e0e0e0',
                          borderRadius: '50%',
                          width: '35px',
                          height: '35px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          zIndex: 2,
                          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        }}
                      >
                        <KeyboardDoubleArrowLeftTwoToneIcon fontSize="small" />
                      </button>
                    )}

                    <div
                      ref={navRef}
                      style={{
                        display: 'flex',
                        backgroundColor: '#FFFFFF',
                        borderRadius: '48px',
                        padding: '6px',
                        overflowX: 'auto',
                        scrollBehavior: 'smooth',
                        margin:
                          orderedCategories?.length > 6 ? '0 0px' : '0 auto',
                        gap: '4px',
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none',
                        WebkitScrollbar: { display: 'none' },
                      }}
                    >
                      {orderedCategories.map((category, index) => (
                        <button
                          key={category.id}
                          type="button"
                          data-category-tab-id={category.id}
                          onClick={() => {
                            handleChangeType(category.id);
                            setEnableAdd(false);
                          }}
                          style={{
                            padding: '8px 32px',
                            backgroundColor:
                              type === category?.id
                                ? environment.mainColor
                                : 'transparent',
                            color:
                              type === category?.id ? '#ffffff' : '#000000',

                            border: 'none',
                            borderRadius: '32px',
                            fontSize: '14px',
                            fontWeight: 700,
                            fontFamily: '"Jost", sans-serif',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            minWidth: 'fit-content',
                            transition: 'all 0.3s ease',
                            textTransform: 'capitalize',
                            boxShadow:
                              type === category?.id
                                ? '0 2px 8px rgba(248, 153, 53, 0.3)'
                                : 'none',
                            textShadow:
                              type === category?.id
                                ? '0 1px 3px rgba(0, 0, 0, 0.3)'
                                : 'none',
                          }}
                        >
                          {category.name}
                        </button>
                      ))}
                    </div>

                    {orderedCategories?.length > (smDown ? 2 : 5) && (
                      <button
                        type="button"
                        onClick={() => handleNav('right')}
                        style={{
                          position: 'absolute',
                          right: '0',
                          background: '#fff',
                          border: '1px solid #e0e0e0',
                          borderRadius: '50%',
                          width: '35px',
                          height: '35px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          zIndex: 2,
                          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        }}
                      >
                        <KeyboardDoubleArrowRightTwoToneIcon fontSize="small" />
                      </button>
                    )}
                  </div>

                  {/* Mobile scroll indicator - only show on mobile when categories are scrollable */}
                  {smDown &&
                    !showMobileStickyCategoryNav &&
                    orderedCategories?.length > 2 && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginTop: '12px',
                        gap: '6px',
                      }}
                    >
                      {/* Scroll indicator dots */}
                      <div
                        style={{
                          width: '4px',
                          height: '4px',
                          borderRadius: '50%',
                          backgroundColor: '#D1D5DB',
                        }}
                      />
                      <div
                        style={{
                          width: '20px',
                          height: '4px',
                          borderRadius: '2px',
                          backgroundColor: environment.mainColor || '#F89935',
                          opacity: 0.6,
                        }}
                      />
                      <div
                        style={{
                          width: '4px',
                          height: '4px',
                          borderRadius: '50%',
                          backgroundColor: '#D1D5DB',
                        }}
                      />
                    </div>
                  )}

                  {/* Optional: Swipe hint text for mobile */}
                  {smDown &&
                    !showMobileStickyCategoryNav &&
                    orderedCategories?.length > 2 && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: '8px',
                      }}
                    >
                      <Typography
                        variant="caption"
                        style={{
                          color: '#9CA3AF',
                          fontSize: '12px',
                          fontFamily: '"Jost", sans-serif',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '4px',
                        }}
                      >
                        <span>👆</span> Swipe to browse categories
                      </Typography>
                    </div>
                  )}
                </div>
                )
              ) : (
                // Original design for other restaurants
                <>
                  <div>
                    {filteredCategories?.length > 5 ? (
                      <button onClick={() => handleNav('left')}>
                        <p className="fa fa-lg fa-chevron-left">
                          <KeyboardDoubleArrowLeftTwoToneIcon />
                        </p>
                      </button>
                    ) : (
                      ''
                    )}
                  </div>
                  <div
                    className="nav-items"
                    ref={navRef}
                    style={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: smDown ? 'start' : 'center',
                    }}
                  >
                    {filteredItems?.length > 0 ? (
                      orderedCategories.map((category, index) => (
                        <Grid
                          item
                          lg={4}
                          key={category.id}
                          style={{
                            display: 'inline-block',
                            color: 'white',
                            textAalign: 'center',
                            padding: '14px',
                            textDecoration: 'none',
                            cursor: 'pointer',
                          }}
                        >
                          <Card
                            key={category.id}
                            style={{
                              border: '2px solid lightgray',
                              borderRadius: '20px',
                              borderColor:
                                type === category?.id &&
                                category?.items_id?.length !== 0
                                  ? environment.mainColor
                                  : 'gray',
                              width: smDown ? '120px' : '140px',
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                              handleChangeType(category.id);
                              setEnableAdd(false);
                            }}
                          >
                            <CardContent
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                textAlign: 'center',
                                flexDirection: 'column',
                                alignItems: 'center',
                              }}
                            >
                              <>
                                <img
                                  src={
                                    category?.category_image_thumb_url ===
                                    'popularImage'
                                      ? popularImage
                                      : category?.category_image_thumb_url
                                  }
                                  alt={category?.category_image_thumb_url}
                                  loading="lazy"
                                  decoding="async"
                                  style={{ width: '60px', height: '60px' }}
                                />
                                <Typography
                                  variant="body1"
                                  style={{
                                    fontWeight: 'bold',
                                    color: 'black',
                                  }}
                                >
                                  {category.name?.length > 12
                                    ? category.name.slice(0, 12)
                                    : category.name}
                                  {category.name?.length > 12 ? '...' : ''}
                                </Typography>
                              </>
                            </CardContent>
                          </Card>
                        </Grid>
                      ))
                    ) : (
                      <Typography
                        variant="body1"
                        style={{
                          color: '#302F3C',
                          marginTop: '30px',
                          fontFamily: `Hanalei Fill, cursive`,
                          fontWeight: 'bold',
                          textAlign: 'center',
                        }}
                      >
                        {t('menu.noCategoryAvaliable')}
                      </Typography>
                    )}
                  </div>
                  <div>
                    {orderedCategories?.length > 5 ? (
                      <button onClick={() => handleNav('right')}>
                        <p className="fa fa-lg fa-chevron-right">
                          <KeyboardDoubleArrowRightTwoToneIcon />
                        </p>
                      </button>
                    ) : (
                      ''
                    )}
                  </div>
                </>
              )}
            </div>
            {filteredItems?.length > 0
              ? orderedCategories.map((category, index) => (
                  <div key={category.id}>
                    {(category.id === type ||
                      (smDown &&
                        (environment?.restaurantId === 'fattyPattyDev' ||
                          environment?.restaurantId === 'fattyPatty'))) && (
                      <Container maxWidth={'lg'}>
                        {environment?.restaurantId === 'fattyPattyDev' ||
                        environment?.restaurantId === 'fattyPatty' ? (
                          // New fattyPattyDev header design
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginBottom: '40px',
                              marginTop: '40px',
                              position: 'relative', // Make the parent container relative to position the underline
                            }}
                          >
                            <Typography
                              variant={'h3'}
                              style={{
                                fontFamily: '"Jost", sans-serif',
                                fontWeight: '900',
                                color: '#000000',
                                fontSize: smDown ? '18px' : '24px',
                                margin: 0,
                                textAlign: 'center',
                                display: 'inline-block',
                                position: 'relative',
                                zIndex: 2,
                              }}
                            >
                              {category.name}
                              {/* Underline div */}
                              <div
                                style={{
                                  position: 'absolute',
                                  bottom: '-5px',
                                  left: '0',
                                  width: '100%',
                                  height: '10px',
                                  opacity: 0.1,
                                  backgroundColor: environment.mainColor,
                                  borderRadius: '1px',
                                  zIndex: 1,
                                }}
                              />
                            </Typography>
                          </div>
                        ) : (
                          // Original header design for other restaurants
                          <Grid
                            key={category.id}
                            container
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginLeft: smDown ? '-10px' : '0px',
                              marginBottom: smDown ? '30px' : '60px',
                            }}
                          >
                            <Typography
                              variant={'h4'}
                              style={{
                                marginTop: '50px',
                                fontFamily: 'Abel',
                              }}
                            >
                              {category.name}
                            </Typography>
                            <div
                              style={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                textAlign: 'center',
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  width: '60%',
                                }}
                              >
                                <span
                                  className="dot"
                                  style={{
                                    backgroundColor: environment.mainColor,
                                  }}
                                ></span>

                                <Divider
                                  style={{
                                    marginBottom: '5px',
                                    marginTop: '5px',
                                    height: '2px',
                                    backgroundColor: environment.mainColor,
                                    width: '30%',
                                    marginLeft: '8px',
                                    marginRight: '8px',
                                  }}
                                />
                                <span
                                  className="dot"
                                  style={{
                                    backgroundColor: environment.mainColor,
                                  }}
                                ></span>
                              </div>
                            </div>
                          </Grid>
                        )}

                        <div
                          id={category?.id}
                          key={index}
                          ref={(el) => {
                            if (el) {
                              categorySectionRefs.current[category.id] = el;
                            }
                          }}
                          data-category-id={category?.id}
                          style={
                            smDown &&
                            (environment?.restaurantId === 'fattyPattyDev' ||
                              environment?.restaurantId === 'fattyPatty')
                              ? {
                                  scrollMarginTop:
                                    (showMobileStickyCategoryNav ? 260 : 0) +
                                    Math.max(mobileStickyCategoryNavHeight, 56) +
                                    8,
                                }
                              : undefined
                          }
                        >
                          {
                            <>
                              {' '}
                              <Grid
                                container
                                spacing={
                                  environment?.restaurantId ===
                                    'fattyPattyDev' ||
                                  environment?.restaurantId === 'fattyPatty'
                                    ? { xs: 2, sm: 3, md: 3 }
                                    : 1
                                }
                                direction="row"
                                sx={{
                                  display:
                                    environment?.restaurantId ===
                                      'fattyPattyDev' ||
                                    environment?.restaurantId === 'fattyPatty'
                                      ? 'flex'
                                      : { sm: 'block', lg: 'flex' },
                                  ...((environment?.restaurantId ===
                                    'fattyPattyDev' ||
                                    environment?.restaurantId ===
                                      'fattyPatty') && {
                                    paddingTop: '80px',
                                    paddingBottom: '40px',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                  }),
                                }}
                              >
                                {/* Per-category empty states */}
                                {category?.id === 'Popular' &&
                                !(
                                  environment?.restaurantId ===
                                    'fattyPattyDev' ||
                                  environment?.restaurantId === 'fattyPatty'
                                )
                                  ? popularItems?.length === 0 && (
                                      <div
                                        style={{
                                          display: 'flex',
                                          flexDirection: 'column',
                                          alignItems: 'center',
                                          justifyContent: 'center',

                                          textAlign: 'center',
                                        }}
                                      >
                                        <img
                                          src={noItems}
                                          alt="No popular items"
                                          loading="lazy"
                                          decoding="async"
                                          style={{
                                            maxWidth: '363px',
                                            width: '100%',
                                            height: 'auto',
                                            marginBottom: '20px',
                                            objectFit: 'cover',
                                          }}
                                        />
                                        <Typography
                                          variant="h6"
                                          sx={{
                                            fontWeight: 700,
                                            marginBottom: '8px',
                                            color: '#172B4D',
                                            fontSize: {
                                              xs: '20px',
                                              md: '28px',
                                              lg: '40px',
                                            },
                                            fontFamily: 'Jost, sans-serif',
                                            textAlign: 'center',
                                          }}
                                        >
                                          No popular items here yet 🍽️
                                        </Typography>
                                        <Typography
                                          variant="body1"
                                          sx={{
                                            color: '#828282',
                                            maxWidth: '300px',
                                            lineHeight: 1.5,
                                            textAlign: 'center',
                                          }}
                                        >
                                          Check out our other categories for
                                          delicious options!
                                        </Typography>
                                      </div>
                                    )
                                  : filteredItems?.filter((item) =>
                                      environment?.restaurantId ===
                                        'fattyPattyDev' ||
                                      environment?.restaurantId === 'fattyPatty'
                                        ? item.category_id === category.id ||
                                          (Array.isArray(item.category_ids) &&
                                            item.category_ids.includes(
                                              category.id
                                            ))
                                        : category.id === item.category_id
                                    )?.length === 0 &&
                                    (environment?.restaurantId ===
                                      'fattyPattyDev' ||
                                      environment?.restaurantId ===
                                        'fattyPatty') && (
                                      <div
                                        style={{
                                          display: 'flex',
                                          flexDirection: 'column',
                                          alignItems: 'center',
                                          justifyContent: 'center',

                                          textAlign: 'center',
                                        }}
                                      >
                                        <img
                                          src={noItems}
                                          alt={`No items in ${category.name}`}
                                          loading="lazy"
                                          decoding="async"
                                          style={{
                                            maxWidth: '363px',
                                            width: '100%',
                                            height: 'auto',
                                            marginBottom: '20px',
                                            objectFit: 'cover',
                                          }}
                                        />
                                        <Typography
                                          variant="h6"
                                          sx={{
                                            fontWeight: 700,
                                            marginBottom: '8px',
                                            color: '#172B4D',
                                            fontSize: {
                                              xs: '20px',
                                              md: '28px',
                                              lg: '40px',
                                            },
                                            fontFamily: 'Jost, sans-serif',
                                            textAlign: 'center',
                                          }}
                                        >
                                          No {category.name} Available
                                        </Typography>
                                        <Typography
                                          variant="body2"
                                          sx={{
                                            color: '#828282',
                                            maxWidth: '300px',
                                            lineHeight: 1.5,
                                            textAlign: 'center',
                                          }}
                                        >
                                          This category is currently unavailable
                                          at this location.
                                        </Typography>
                                      </div>
                                    )}
                                {/* {items
                              .filter(
                                (item) =>
                                  category.id === item.category_id ||
                                  ((item.store_ids?.includes(user.defaultStore) || item.store_id === user.defaultStore) &&
                                    // category.id === item.category_id &&
                                    item.is_popular &&
                                    category.id === 'Popular')
                              ) */}
                                {category?.id === 'Popular'
                                  ? popularItems.map(
                                      (item, index) =>
                                        item.item_state === 'available' && (
                                          <>
                                            {environment?.restaurantId ===
                                            'elmbrookschools' ? (
                                              <Grid
                                                key={item.id}
                                                item
                                                lg={3}
                                                sm={6}
                                                style={{
                                                  marginTop: '30px',
                                                  marginBottom: '50px',
                                                  display: 'grid',
                                                }}
                                              >
                                                <div
                                                  onClick={() =>
                                                    handleOpen(item?.id, item)
                                                  }
                                                ></div>
                                                <div className="menu-item-image-container">
                                                  <div
                                                    className="menu-item-image-circle"
                                                    style={{
                                                      backgroundColor:
                                                        '#fadcbb',
                                                      borderRadius: '100px',
                                                      width: '200px',
                                                      backgroundImage:
                                                        ' linear-gradient(to top, #FBF1EA, #FBF1EA, #FFFDFC, #FFFDFC, #FFFDFC)',
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        display: 'flex',
                                                        justifyContent:
                                                          'center',
                                                      }}
                                                    >
                                                      <img
                                                        src={
                                                          item?.item_image_url
                                                        }
                                                        alt="Menu Item"
                                                        loading="lazy"
                                                        decoding="async"
                                                        style={{
                                                          height: '80%',
                                                          width: '80%',
                                                        }}
                                                      />
                                                    </div>

                                                    <div
                                                      style={{
                                                        display: 'flex',
                                                        justifyContent:
                                                          'center',
                                                        marginTop: '10px',
                                                      }}
                                                    >
                                                      <Button
                                                        variant="contained"
                                                        style={{
                                                          backgroundColor:
                                                            'white',
                                                          color:
                                                            environment.primaryColor,
                                                          borderRadius: '30px',
                                                        }}
                                                        onClick={() =>
                                                          handleOpen(
                                                            item?.id,
                                                            item
                                                          )
                                                        }
                                                      >
                                                        Add to cart
                                                      </Button>
                                                    </div>
                                                  </div>
                                                  <div
                                                    style={{
                                                      width: '64%',
                                                      display: 'flex',
                                                      justifyContent: 'center',
                                                      textAlign: 'center',
                                                    }}
                                                  >
                                                    <Typography
                                                      variant="h5"
                                                      style={{
                                                        color:
                                                          environment.primaryColor,
                                                      }}
                                                    >
                                                      {item?.name}
                                                    </Typography>
                                                  </div>
                                                </div>
                                              </Grid>
                                            ) : (
                                              <>
                                                {environment?.restaurantId ===
                                                  'fattyPattyDev' ||
                                                environment?.restaurantId ===
                                                  'fattyPatty' ? (
                                                  <FattyPattyMenuCard
                                                    item={item}
                                                    handleOpen={handleOpen}
                                                    storeId={storeId}
                                                  />
                                                ) : (
                                                  // Original design for other restaurants
                                                  <>
                                                    <Hidden smDown>
                                                      <Grid item sm={6} lg={6}>
                                                        <div
                                                          className="menu-item-card"
                                                          onClick={() =>
                                                            handleOpen(
                                                              item?.id,
                                                              item
                                                            )
                                                          }
                                                        >
                                                          <div className="menu-item-details">
                                                            <Grid
                                                              item
                                                              lg={8}
                                                              xl={8}
                                                            >
                                                              <Typography
                                                                variant={
                                                                  'body1'
                                                                }
                                                                style={{
                                                                  fontWeight:
                                                                    'bold',
                                                                  color:
                                                                    '#833720',
                                                                  display:
                                                                    'flex',
                                                                }}
                                                              >
                                                                {item.isCatering ? (
                                                                  <>
                                                                    <FiMinusSquare
                                                                      style={{
                                                                        marginTop:
                                                                          '4px',
                                                                        marginRight:
                                                                          '3px',
                                                                      }}
                                                                    />
                                                                    {'Catering'}
                                                                  </>
                                                                ) : (
                                                                  ''
                                                                )}
                                                              </Typography>
                                                            </Grid>
                                                            <h6 className="menu-item-title">
                                                              {item?.name}
                                                            </h6>
                                                            <p className="menu-item-description">
                                                              {item?.description
                                                                ?.length > 99
                                                                ? item?.description.slice(
                                                                    0,
                                                                    99
                                                                  )
                                                                : item?.description}
                                                              {item?.description
                                                                ?.length > 99
                                                                ? '...'
                                                                : ''}
                                                            </p>
                                                          </div>
                                                          <div className="menu-item-image-container">
                                                            <img
                                                              src={
                                                                item?.item_image_url
                                                              }
                                                              alt="Menu Item"
                                                              loading="lazy"
                                                              decoding="async"
                                                              className="menu-item-image"
                                                            />
                                                            <button className="menu-item-button">
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    '12px',
                                                                }}
                                                              >
                                                                {t('menu.add')}
                                                              </p>
                                                            </button>
                                                          </div>
                                                        </div>
                                                      </Grid>
                                                    </Hidden>
                                                    {/* //in mobile */}
                                                    {/* Text content */}
                                                    <Hidden smUp>
                                                      <Grid
                                                        item
                                                        sm={12}
                                                        lg={12}
                                                      >
                                                        <div
                                                          className="menu-item-card2"
                                                          onClick={() =>
                                                            handleOpen(
                                                              item?.id,
                                                              item
                                                            )
                                                          }
                                                          style={{
                                                            paddingBottom:
                                                              '0px',
                                                          }}
                                                        >
                                                          <div className="menu-item-details">
                                                            <h6
                                                              className="menu-item-title"
                                                              style={{
                                                                fontWeight:
                                                                  'bold',
                                                                fontSize:
                                                                  '.9rem',
                                                                marginTop:
                                                                  '-12px',
                                                              }}
                                                            >
                                                              {item?.name}
                                                            </h6>
                                                            <p
                                                              className="menu-item-description"
                                                              style={{
                                                                marginTop:
                                                                  '10px',
                                                                fontSize:
                                                                  '.6rem',
                                                                paddingBottom:
                                                                  '0px',
                                                                // ====
                                                              }}
                                                            >
                                                              {item?.description
                                                                .length > 99
                                                                ? item?.description.slice(
                                                                    0,
                                                                    99
                                                                  )
                                                                : item?.description}
                                                              {item?.description
                                                                .length > 99
                                                                ? '...'
                                                                : ''}
                                                            </p>
                                                          </div>
                                                          <div className="menu-item-image-container2">
                                                            <img
                                                              src={
                                                                item?.item_image_url
                                                              }
                                                              alt="Menu Item"
                                                              loading="lazy"
                                                              decoding="async"
                                                              className="menu-item-image"
                                                            />
                                                            <button
                                                              className="menu-item-button"
                                                              style={{
                                                                paddingRight:
                                                                  '10px',
                                                              }}
                                                            >
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    '11px',
                                                                }}
                                                              >
                                                                {t('menu.add')}
                                                              </p>
                                                            </button>
                                                          </div>
                                                        </div>
                                                      </Grid>
                                                    </Hidden>
                                                  </>
                                                )}
                                              </>
                                            )}{' '}
                                            {item?.id === id ? (
                                              environment?.restaurantId ===
                                                'fattyPattyDev' ||
                                              environment?.restaurantId ===
                                                'fattyPatty' ? (
                                                <FattyPattyDialog
                                                  open={open}
                                                  handleClose={handleClose}
                                                  item={item}
                                                  handleOpen={handleOpen}
                                                  modifiers={modifiers}
                                                  storeId={storeId}
                                                  editCartItem={
                                                    pendingEditCartItem
                                                  }
                                                />
                                              ) : (
                                                <CustomizeDialoge
                                                  open={open}
                                                  handleClose={handleClose}
                                                  option={option}
                                                  c={item}
                                                  priceToShow={
                                                    item?.price + optionsPrice1
                                                  }
                                                  data={data}
                                                  defs={defs}
                                                  defaultPrices={optionsPrice1}
                                                  extraQuantity={extraQuantity}
                                                  setExtraQuantity={
                                                    setExtraQuantity
                                                  }
                                                  outofStockDelivery={
                                                    outofStockDelivery
                                                  }
                                                  openn={openn}
                                                  handleClosee={handleClosee}
                                                  handleOpenn={handleOpenn}
                                                  enableAdd={enableAdd}
                                                />
                                              )
                                            ) : (
                                              ''
                                            )}
                                          </>
                                        )
                                    )
                                  : filteredItems
                                      ?.filter((item) =>
                                        environment?.restaurantId ===
                                          'fattyPattyDev' ||
                                        environment?.restaurantId ===
                                          'fattyPatty'
                                          ? item.category_id === category.id ||
                                            (Array.isArray(item.category_ids) &&
                                              item.category_ids.includes(
                                                category.id
                                              ))
                                          : category.id === item.category_id
                                      )
                                      .map(
                                        (item, index) =>
                                          // console.log(item,"item")
                                          item.item_state === 'available' && (
                                            <>
                                              {environment?.restaurantId ===
                                              'elmbrookschools' ? (
                                                <Grid
                                                  key={item.id}
                                                  item
                                                  lg={3}
                                                  sm={6}
                                                  style={{
                                                    marginTop: '30px',
                                                    marginBottom: '50px',
                                                    display: 'grid',
                                                  }}
                                                >
                                                  <div
                                                    onClick={() =>
                                                      handleOpen(item?.id, item)
                                                    }
                                                  ></div>
                                                  <div className="menu-item-image-container">
                                                    <div
                                                      className="menu-item-image-circle"
                                                      style={{
                                                        backgroundColor:
                                                          '#fadcbb',
                                                        borderRadius: '100px',
                                                        width: '200px',
                                                        backgroundImage:
                                                          ' linear-gradient(to top, #FBF1EA, #FBF1EA, #FFFDFC, #FFFDFC, #FFFDFC)',
                                                      }}
                                                    >
                                                      <div
                                                        style={{
                                                          display: 'flex',
                                                          justifyContent:
                                                            'center',
                                                        }}
                                                      >
                                                        <img
                                                          src={
                                                            item?.item_image_url
                                                          }
                                                          alt="Menu Item"
                                                          loading="lazy"
                                                          decoding="async"
                                                          style={{
                                                            height: '80%',
                                                            width: '80%',
                                                          }}
                                                        />
                                                      </div>

                                                      <div
                                                        style={{
                                                          display: 'flex',
                                                          justifyContent:
                                                            'center',
                                                          marginTop: '10px',
                                                        }}
                                                      >
                                                        <Button
                                                          variant="contained"
                                                          style={{
                                                            backgroundColor:
                                                              'white',
                                                            color:
                                                              environment.primaryColor,
                                                            borderRadius:
                                                              '30px',
                                                          }}
                                                          onClick={() =>
                                                            handleOpen(
                                                              item?.id,
                                                              item
                                                            )
                                                          }
                                                        >
                                                          Add to cart
                                                        </Button>
                                                      </div>
                                                    </div>
                                                    <div
                                                      style={{
                                                        width: '64%',
                                                        display: 'flex',
                                                        justifyContent:
                                                          'center',
                                                        textAlign: 'center',
                                                      }}
                                                    >
                                                      <Typography
                                                        variant="h5"
                                                        style={{
                                                          color:
                                                            environment.primaryColor,
                                                        }}
                                                      >
                                                        {item?.name}
                                                      </Typography>
                                                    </div>
                                                  </div>
                                                </Grid>
                                              ) : (
                                                <>
                                                  {environment?.restaurantId ===
                                                    'fattyPattyDev' ||
                                                  environment?.restaurantId ===
                                                    'fattyPatty' ? (
                                                    <FattyPattyMenuCard
                                                      item={item}
                                                      handleOpen={handleOpen}
                                                      storeId={storeId}
                                                    />
                                                  ) : (
                                                    // Original design for other restaurants
                                                    <>
                                                      <Hidden smDown>
                                                        <Grid
                                                          item
                                                          sm={6}
                                                          lg={6}
                                                        >
                                                          <div
                                                            className="menu-item-card"
                                                            onClick={() =>
                                                              handleOpen(
                                                                item?.id,
                                                                item
                                                              )
                                                            }
                                                          >
                                                            <div className="menu-item-details">
                                                              <Grid
                                                                item
                                                                lg={8}
                                                                xl={8}
                                                              >
                                                                <Typography
                                                                  variant={
                                                                    'body1'
                                                                  }
                                                                  style={{
                                                                    fontWeight:
                                                                      'bold',
                                                                    color:
                                                                      '#833720',
                                                                    display:
                                                                      'flex',
                                                                  }}
                                                                >
                                                                  {item.isCatering ? (
                                                                    <>
                                                                      <FiMinusSquare
                                                                        style={{
                                                                          marginTop:
                                                                            '4px',
                                                                          marginRight:
                                                                            '3px',
                                                                        }}
                                                                      />
                                                                      {
                                                                        'Catering'
                                                                      }
                                                                    </>
                                                                  ) : (
                                                                    ''
                                                                  )}
                                                                </Typography>
                                                              </Grid>
                                                              <h6 className="menu-item-title">
                                                                {item?.name}
                                                              </h6>
                                                              <p className="menu-item-description">
                                                                {item
                                                                  ?.description
                                                                  ?.length > 99
                                                                  ? item?.description.slice(
                                                                      0,
                                                                      99
                                                                    )
                                                                  : item?.description}
                                                                {item
                                                                  ?.description
                                                                  ?.length > 99
                                                                  ? '...'
                                                                  : ''}
                                                              </p>
                                                            </div>
                                                            <div className="menu-item-image-container">
                                                              <img
                                                                src={
                                                                  item?.item_image_url
                                                                }
                                                                alt="Menu Item"
                                                                loading="lazy"
                                                                decoding="async"
                                                                className="menu-item-image"
                                                              />
                                                              <button className="menu-item-button">
                                                                <p
                                                                  style={{
                                                                    fontSize:
                                                                      '12px',
                                                                  }}
                                                                >
                                                                  {t(
                                                                    'menu.add'
                                                                  )}
                                                                </p>
                                                              </button>
                                                            </div>
                                                          </div>
                                                        </Grid>
                                                      </Hidden>
                                                      {/* //in mobile */}
                                                      {/* Text content */}
                                                      <Hidden smUp>
                                                        <Grid
                                                          item
                                                          sm={12}
                                                          lg={12}
                                                        >
                                                          <div
                                                            className="menu-item-card2"
                                                            onClick={() =>
                                                              handleOpen(
                                                                item?.id,
                                                                item
                                                              )
                                                            }
                                                            style={{
                                                              paddingBottom:
                                                                '0px',
                                                            }}
                                                          >
                                                            <div className="menu-item-details">
                                                              <h6
                                                                className="menu-item-title"
                                                                style={{
                                                                  fontWeight:
                                                                    'bold',
                                                                  fontSize:
                                                                    '.9rem',
                                                                  marginTop:
                                                                    '-12px',
                                                                }}
                                                              >
                                                                {item?.name}
                                                              </h6>
                                                              <p
                                                                className="menu-item-description"
                                                                style={{
                                                                  marginTop:
                                                                    '10px',
                                                                  fontSize:
                                                                    '.6rem',
                                                                  paddingBottom:
                                                                    '0px',
                                                                  // ====
                                                                }}
                                                              >
                                                                {item
                                                                  ?.description
                                                                  .length > 99
                                                                  ? item?.description.slice(
                                                                      0,
                                                                      99
                                                                    )
                                                                  : item?.description}
                                                                {item
                                                                  ?.description
                                                                  .length > 99
                                                                  ? '...'
                                                                  : ''}
                                                              </p>
                                                            </div>
                                                            <div className="menu-item-image-container2">
                                                              <img
                                                                src={
                                                                  item?.item_image_url
                                                                }
                                                                alt="Menu Item"
                                                                loading="lazy"
                                                                decoding="async"
                                                                className="menu-item-image"
                                                              />
                                                              <button
                                                                className="menu-item-button"
                                                                style={{
                                                                  paddingRight:
                                                                    '10px',
                                                                }}
                                                              >
                                                                <p
                                                                  style={{
                                                                    fontSize:
                                                                      '11px',
                                                                  }}
                                                                >
                                                                  {t(
                                                                    'menu.add'
                                                                  )}
                                                                </p>
                                                              </button>
                                                            </div>
                                                          </div>
                                                        </Grid>
                                                      </Hidden>
                                                    </>
                                                  )}
                                                </>
                                              )}{' '}
                                              {item?.id === id ? (
                                                environment?.restaurantId ===
                                                  'fattyPattyDev' ||
                                                environment?.restaurantId ===
                                                  'fattyPatty' ? (
                                                  <FattyPattyDialog
                                                    open={open}
                                                    handleClose={handleClose}
                                                    item={item}
                                                    handleOpen={handleOpen}
                                                    modifiers={modifiers}
                                                    storeId={storeId}
                                                    editCartItem={
                                                      pendingEditCartItem
                                                    }
                                                  />
                                                ) : (
                                                  <CustomizeDialoge
                                                    open={open}
                                                    handleClose={handleClose}
                                                    option={option}
                                                    c={item}
                                                    priceToShow={
                                                      item?.price +
                                                      optionsPrice1
                                                    }
                                                    data={data}
                                                    defs={defs}
                                                    defaultPrices={
                                                      optionsPrice1
                                                    }
                                                    extraQuantity={
                                                      extraQuantity
                                                    }
                                                    setExtraQuantity={
                                                      setExtraQuantity
                                                    }
                                                    outofStockDelivery={
                                                      outofStockDelivery
                                                    }
                                                    openn={openn}
                                                    handleClosee={handleClosee}
                                                    handleOpenn={handleOpenn}
                                                    enableAdd={enableAdd}
                                                  />
                                                )
                                              ) : (
                                                ''
                                              )}
                                            </>
                                          )
                                      )}
                              </Grid>
                            </>
                          }
                        </div>
                      </Container>
                    )}
                  </div>
                ))
              : ''}

            {
              /* {menuess?.map((c) => (
        <div>
          {c.category_id?.length > 0 &&
            c.category_id?.map(
              (category, index) =>
                category.id === type && (
                  <Container maxWidth={'lg'}>
                    <Grid
                      key={category.id}
                      container
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginLeft: smDown ? '-10px' : '0px',
                        marginBottom: smDown ? '30px' : '60px',
                      }}
                    >
                      {categories
                        .filter((c) => c?.id === category?.id)
                        .map((dataCategory) => (
                          <Typography
                            variant={'h4'}
                            style={{
                              marginTop: '50px',
                              fontFamily: 'Abel',
                            }}
                          >
                            {dataCategory.name}
                          </Typography>
                        ))}
                      <div
                        style={{
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'center',
                          textAlign: 'center',
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            width: '60%',
                          }}
                        >
                          <span
                            className="dot"
                            style={{ backgroundColor: environment.mainColor }}
                          ></span>

                          <Divider
                            style={{
                              marginBottom: '5px',
                              marginTop: '5px',
                              height: '2px',
                              backgroundColor: environment.mainColor,
                              width: '30%',
                              marginLeft: '8px',
                              marginRight: '8px',
                            }}
                          />
                          <span
                            className="dot"
                            style={{ backgroundColor: environment.mainColor }}
                          ></span>
                        </div>
                      </div>
                    </Grid>

                    <div id={category?.id} key={index}>
                      {
                        <>
                          {' '}
                          <Grid
                            container
                            spacing={1}
                            direction="row"
                            sx={{
                              display: { sm: 'block', lg: 'flex' },
                            }}
                          >
                            {category.items_id?.length > 0 &&
                              items
                                .filter((item) =>
                                  category.items_id.includes(item.id)
                                )
                                .map(
                                  (item, index) =>
                                    item.item_state === 'available' && (
                                      <Box>
                                        {environment?.restaurantId ===
                                        'elmbrookschools' ? (
                                          <Grid
                                            key={item.id}
                                            item
                                            lg={3}
                                            sm={6}
                                            style={{
                                              marginTop: '30px',
                                              marginBottom: '50px',
                                              display: 'grid',
                                            }}
                                          >
                                            <div
                                              onClick={() =>
                                                handleOpen(item?.id, item)
                                              }
                                            ></div>
                                            <div className="menu-item-image-container">
                                              <div
                                                className="menu-item-image-circle"
                                                style={{
                                                  backgroundColor: '#fadcbb',
                                                  borderRadius: '100px',
                                                  width: '200px',
                                                  backgroundImage:
                                                    ' linear-gradient(to top, #FBF1EA, #FBF1EA, #FFFDFC, #FFFDFC, #FFFDFC)',
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                  }}
                                                >
                                                  <img
                                                    src={item?.item_image_url}
                                                    alt="Menu Item"
                                                    loading="lazy"
                                                    decoding="async"
                                                    style={{
                                                      height: '80%',
                                                      width: '80%',
                                                    }}
                                                  />
                                                </div>

                                                <div
                                                  style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    marginTop: '10px',
                                                  }}
                                                >
                                                  <Button
                                                    variant="contained"
                                                    style={{
                                                      backgroundColor: 'white',
                                                      color:
                                                        environment.primaryColor,
                                                      borderRadius: '30px',
                                                    }}
                                                    onClick={() =>
                                                      handleOpen(item?.id, item)
                                                    }
                                                  >
                                                    Add to cart
                                                  </Button>
                                                </div>
                                              </div>
                                              <div
                                                style={{
                                                  width: '64%',
                                                  display: 'flex',
                                                  justifyContent: 'center',
                                                  textAlign: 'center',
                                                }}
                                              >
                                                <Typography
                                                  variant="h5"
                                                  style={{
                                                    color:
                                                      environment.primaryColor,
                                                  }}
                                                >
                                                  {item?.name}
                                                </Typography>
                                              </div>
                                            </div>
                                          </Grid>
                                        ) : (
                                          <>
                                            {' '}
                                            <Hidden smDown>
                                              <Grid item sm={6} lg={6}>
                                                <div
                                                  className="menu-item-card"
                                                  onClick={() =>
                                                    handleOpen(item?.id, item)
                                                  }
                                                >
                                                  <div className="menu-item-details">
                                                    <Grid item lg={8} xl={8}>
                                                      <Typography
                                                        variant={'body1'}
                                                        style={{
                                                          fontWeight: 'bold',
                                                          color: '#833720',
                                                          display: 'flex',
                                                        }}
                                                      >
                                                        {item.isCatering ? (
                                                          <>
                                                            <FiMinusSquare
                                                              style={{
                                                                marginTop:
                                                                  '4px',
                                                                marginRight:
                                                                  '3px',
                                                              }}
                                                            />
                                                            {'Catering'}
                                                          </>
                                                        ) : (
                                                          ''
                                                        )}
                                                      </Typography>
                                                    </Grid>
                                                    <h6 className="menu-item-title">
                                                      {item?.name}
                                                    </h6>
                                                    <p className="menu-item-description">
                                                      {item?.description
                                                        ?.length > 99
                                                        ? item?.description.slice(
                                                            0,
                                                            99
                                                          )
                                                        : item?.description}
                                                      {item?.description
                                                        ?.length > 99
                                                        ? '...'
                                                        : ''}
                                                    </p>
                                                  </div>
                                                  <div className="menu-item-image-container">
                                                    <img
                                                      src={item?.item_image_url}
                                                      alt="Menu Item"
                                                      loading="lazy"
                                                      decoding="async"
                                                      className="menu-item-image"
                                                    />
                                                    <button className="menu-item-button">
                                                      <p
                                                        style={{
                                                          fontSize: '12px',
                                                        }}
                                                      >
                                                        {t('menu.add')}
                                                      </p>
                                                    </button>
                                                  </div>
                                                </div>
                                              </Grid>
                                            </Hidden>
                                            {/* //in mobile
                                            {/* Text content
                                            <Hidden smUp>
                                              <Grid item sm={12} lg={12}>
                                                <div
                                                  className="menu-item-card2"
                                                  onClick={() =>
                                                    handleOpen(item?.id, item)
                                                  }
                                                  style={{
                                                    paddingBottom: '0px',
                                                  }}
                                                >
                                                  <div className="menu-item-details">
                                                    <h6
                                                      className="menu-item-title"
                                                      style={{
                                                        fontWeight: 'bold',
                                                        fontSize: '.9rem',
                                                        marginTop: '-12px',
                                                      }}
                                                    >
                                                      {item?.name}
                                                    </h6>
                                                    <p
                                                      className="menu-item-description"
                                                      style={{
                                                        marginTop: '10px',
                                                        fontSize: '.6rem',
                                                        paddingBottom: '0px',
                                                        // ====
                                                      }}
                                                    >
                                                      {item?.description
                                                        .length > 99
                                                        ? item?.description.slice(
                                                            0,
                                                            99
                                                          )
                                                        : item?.description}
                                                      {item?.description
                                                        .length > 99
                                                        ? '...'
                                                        : ''}
                                                    </p>
                                                  </div>
                                                  <div className="menu-item-image-container2">
                                                    <img
                                                      src={item?.item_image_url}
                                                      alt="Menu Item"
                                                      loading="lazy"
                                                      decoding="async"
                                                      className="menu-item-image"
                                                    />
                                                    <button
                                                      className="menu-item-button"
                                                      style={{
                                                        paddingRight: '10px',
                                                      }}
                                                    >
                                                      <p
                                                        style={{
                                                          fontSize: '11px',
                                                        }}
                                                      >
                                                        {t('menu.add')}
                                                      </p>
                                                    </button>
                                                  </div>
                                                </div>
                                              </Grid>
                                            </Hidden>
                                            {/* Image
                                            {/* Divider
                                            {/* ======
                                          </>
                                        )}

                                        {item?.id === id ? (
                                          environment?.restaurantId === 'fattyPattyDev' ? (
                                            <FattyPattyDialog
                                              open={open}
                                              handleClose={handleClose}
                                              item={item}
                                              handleOpen={handleOpen}
                                              editCartItem={pendingEditCartItem}
                                            />
                                          ) : (
                                            <CustomizeDialoge
                                              open={open}
                                              handleClose={handleClose}
                                              option={option}
                                              c={item}
                                              priceToShow={
                                                item?.price + optionsPrice1
                                              }
                                              data={data}
                                              defs={defs}
                                              defaultPrices={optionsPrice1}
                                              extraQuantity={extraQuantity}
                                              setExtraQuantity={setExtraQuantity}
                                              outofStockDelivery={
                                                outofStockDelivery
                                              }
                                              openn={openn}
                                              handleClosee={handleClosee}
                                              handleOpenn={handleOpenn}
                                              enableAdd={enableAdd}
                                            />
                                          )
                                        ) : (
                                          ''
                                        )}
                                      </>
                                    )
                                )}
                          </Grid>
                        </>
                      }
                    </div>
                  </Container>
                )
            ) : (
              /* Empty state when there are categories but no items for selected store */
              filteredCategories?.length > 0 &&
                filteredItems?.length === 0 &&
                !(
                  environment?.restaurantId === 'fattyPattyDev' ||
                  environment?.restaurantId === 'fattyPatty'
                ) && (
                  <Container maxWidth="lg" sx={{ textAlign: 'center', py: 8 }}>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <img
                        src={noItems}
                        alt="No items available"
                        loading="lazy"
                        decoding="async"
                        style={{
                          maxWidth: '363px',
                          width: '100%',
                          height: 'auto',
                          marginBottom: '20px',
                          objectFit: 'cover',
                        }}
                      />
                      <Typography
                        variant="h5"
                        sx={{
                          fontWeight: 700,
                          marginBottom: '8px',
                          color: '#172B4D',
                          fontSize: {
                            xs: '20px',
                            md: '28px',
                            lg: '40px',
                          },
                          fontFamily: 'Jost, sans-serif',
                          textAlign: 'center',
                        }}
                      >
                        No Items Available
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          color: '#828282',
                          maxWidth: '300px',
                          lineHeight: 1.5,
                          textAlign: 'center',
                        }}
                      >
                        This location currently has no menu items available.
                        Please try another location or check back later.
                      </Typography>
                    </div>
                  </Container>
                )
            }

            {/* ...existing menu content... */}
            {/* The entire menu rendering logic that was inside menu-container goes here. */}
          </>
        )}

        {/* Show message when no store is selected */}
        {!selectedStore && !isLoadingStoreMenu && (
          <Container maxWidth="lg" sx={{ textAlign: 'center', py: 8 }}>
            <Typography variant="h5" gutterBottom color="text.secondary">
              Please select a store to view the menu
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Use the location selector above to find stores near you
            </Typography>
          </Container>
        )}

        {/* Location Change Dialog */}
        {(environment?.restaurantId === 'fattyPattyDev' ||
          environment?.restaurantId === 'fattyPatty') && (
          <DeliveryDialog
            open={locationDialogOpen}
            handleClose={() => setLocationDialogOpen(false)}
            items={userAddresses}
            token={user?.uid}
            setErr={() => {}}
            handleDefault={() => {}}
            handleCloseCartDialoge={() => {}}
            setAddressStore={() => {}}
            handleFee={() => {}}
            setApiError={() => {}}
          />
        )}

        {/* Change Branch Dialog */}
        <ChangeBranchMenu
          isOpen={changeBranchDialogOpen}
          onClose={() => setChangeBranchDialogOpen(false)}
          onSelectBranch={(
            selectedBranch,
            location,
            serviceType,
            preserveScheduledTime
          ) => {
            // Update the selected store using the existing handler
            handleStoreSelected(
              selectedBranch,
              location,
              serviceType,
              preserveScheduledTime
            );
            setChangeBranchDialogOpen(false);
          }}
          userLocation={hookUserLocation}
          savedDeliveryAddress={savedDeliveryAddressForDialog}
        />

        {/* Scheduling Dialog for changing time from banner */}
        <SchedulingDialog
          open={showSchedulingDialog}
          onClose={() => setShowSchedulingDialog(false)}
          onConfirm={handleSchedulingConfirmFromBanner}
          store={currentStoreForScheduling}
          orderType={
            user?.pickupOrDelivery ||
            (currentStoreForScheduling?.delivery_enabled
              ? 'delivery'
              : 'pickup')
          }
          isStoreOpen={currentStoreStatus?.isOpen}
        />

        {/* Initial Branch Selection Dialog */}
        <ChangeBranchMenu
          isOpen={showInitialBranchDialog}
          onClose={() => {
            // If scheduling was just confirmed, don't clear it
            if (schedulingJustConfirmedRef.current) {
              schedulingJustConfirmedRef.current = false;
            } else {
              // User cancelled - close dialog and auto-select nearest store
              // Clear any scheduled time since user didn't confirm a store selection
              dispatch(UpdateScheduledTime(null));
            }

            setClearAddressWhenBranchDialogOpens(false);
            setShowInitialBranchDialog(false);
            setHasUserCancelledDialog(true);
          }}
          onSelectBranch={(
            selectedBranch,
            location,
            serviceType,
            preserveScheduledTime
          ) => {
            // User selected a branch - handle selection and close dialog
            // If preserveScheduledTime is true, mark that scheduling was just confirmed
            if (preserveScheduledTime) {
              schedulingJustConfirmedRef.current = true;
            }

            handleStoreSelected(
              selectedBranch,
              location,
              serviceType,
              preserveScheduledTime
            );
            setShowInitialBranchDialog(false);
          }}
          userLocation={hookUserLocation}
          savedDeliveryAddress={
            clearAddressWhenBranchDialogOpens
              ? null
              : savedDeliveryAddressForDialog
          }
          clearAddressOnOpen={clearAddressWhenBranchDialogOpens}
        />

        <Loading
          loading={!!loading}
          background="rgba(86, 100, 210, 0.1)"
          loaderColor={environment.mainColor}
        />
      </Box>
    </>
  );
}
export default MenuItems2;
